// Autogenerated from 'http://s00-dms2.global.fum:21807/DEV180_DMS/WS/Unsere Verwaltung' on '04.06.2021 10:02:09'
import { INavMethodConfig, NavPageItem, IPageObj } from '../navdata';

export var Pages = {
  FDRW_WFInstance: {
    PageName: "FDRW_WFInstance",
    Methods: {
      Close: (wFInstance: string, keepInstanceCheckedOut: boolean) => {
        return <INavMethodConfig>{
          MethodName: "Close",
          Parameters: { wFInstance: wFInstance, keepInstanceCheckedOut: keepInstanceCheckedOut }
        };
      },
      DeleteFile: (wFInstance: string, wFDocID: string) => {
        return <INavMethodConfig>{
          MethodName: "DeleteFile",
          Parameters: { wFInstance: wFInstance, wFDocID: wFDocID }
        };
      },
      Open: <INavMethodConfig>{ MethodName: "Open" },
      Route: <INavMethodConfig>{ MethodName: "Route" },
      ReserveFunds: <INavMethodConfig>{ MethodName: "ReserveFunds" },
      RenameFile: (wFInstance: string, wFDocID: string, description: string) => {
        return <INavMethodConfig>{
          MethodName: "RenameFile",
          Parameters: { wFInstance: wFInstance, wFDocID: wFDocID, description: description }
        };
      },
      StartBreakout: (wFInstance: string, breakoutID: string, recID: string) => {
        return <INavMethodConfig>{
          MethodName: "StartBreakout",
          Parameters: { wFInstance: wFInstance, breakoutID: breakoutID, recID: recID }
        };
      },
      CancelBreakout: <INavMethodConfig>{ MethodName: "CancelBreakout" },
      GetBreakoutUrlWinClient: <INavMethodConfig>{ MethodName: "GetBreakoutUrlWinClient" },
      GetBreakoutUrlWebClient: <INavMethodConfig>{ MethodName: "GetBreakoutUrlWebClient" },
      CreateWorkflowLogEntry: (wFInstance: string, entryType: number, eventType: number, description: string) => {
        return <INavMethodConfig>{
          MethodName: "CreateWorkflowLogEntry",
          Parameters: { wFInstance: wFInstance, entryType: entryType, eventType: eventType, description: description }
        };
      },
      CheckOrderOverrun: <INavMethodConfig>{ MethodName: "CheckOrderOverrun" },
    },
  },
  FDRW_WFInstanceCompleted: {
    PageName: "FDRW_WFInstanceCompleted",
    Fields: {
      ID: "ID",
      IDAsText: "IDAsText",
      EntryNo: "EntryNo",
      WorkflowType: "WorkflowType",
      LastChanged: "LastChanged",
      LastChangedBy: "LastChangedBy",
      Created: "Created",
      Finished: "Finished",
      WorkflowConfiguration_No: "WorkflowConfiguration_No",
      WorkflowConfiguration_Name: "WorkflowConfiguration_Name",
      Documents: "Documents",
      CurrentWorkflowPart: "CurrentWorkflowPart",
      CurrentWorkflowStep: "CurrentWorkflowStep",
      InitialWorkflowPart: "InitialWorkflowPart",
      InitialWorkflowStep: "InitialWorkflowStep",
      CurrentWorkflowPart_Name: "CurrentWorkflowPart_Name",
      CurrentWorkflowStep_Name: "CurrentWorkflowStep_Name",
      InitialWorkflowPart_Name: "InitialWorkflowPart_Name",
      InitialWorkflowStep_Name: "InitialWorkflowStep_Name",
      StorageProvider: "StorageProvider",
      TransactionNoFilter: "TransactionNoFilter",
      AccountingMode: "AccountingMode",
      ManuallyStarted: "ManuallyStarted",
      Workflow_Log_Entries_Cpl_Sub: "Workflow_Log_Entries_Cpl_Sub",
      Workflow_Archive_Document_Sub: "Workflow_Archive_Document_Sub",
      WF_GL_Entry_Subpage: "WF_GL_Entry_Subpage",
      WF_CL_Entry_Subpage: "WF_CL_Entry_Subpage",
      WF_VL_Entry_Subpage: "WF_VL_Entry_Subpage",
      WF_FA_Entry_Subpage: "WF_FA_Entry_Subpage",
      RegPurchOrderLinesSub: "RegPurchOrderLinesSub",
      SourceRecordDetails: "SourceRecordDetails",
      Workflow_Add_Information: "Workflow_Add_Information",
      WF_PK_Entry_Subpage: "WF_PK_Entry_Subpage",
      WF_HHST_Entry_Subpage: "WF_HHST_Entry_Subpage",
    },
  },
  FDRW_Workflow_User_Instances_List: {
    PageName: "FDRW_Workflow_User_Instances_List",
    Fields: {
      ID: "ID",
      CheckedOutBy: "CheckedOutBy",
      CheckedOutSince: "CheckedOutSince",
      CurrentWorkflowUser: "CurrentWorkflowUser",
      CurrentWorkflowPart: "CurrentWorkflowPart",
      CurrentWorkflowStep: "CurrentWorkflowStep",
      LastStatusInfo: "LastStatusInfo",
      Created: "Created",
      LastStatusChange: "LastStatusChange",
      Receipt_Date: "Receipt_Date",
      VendorCustomerNo: "VendorCustomerNo",
      Document_Date: "Document_Date",
      Due_Date: "Due_Date",
      Posting_Date: "Posting_Date",
      External_Document_No: "External_Document_No",
      Allocation_Template: "Allocation_Template",
      Document_No: "Document_No",
      Order_No: "Order_No",
      Accounting: "Accounting",
      Erweiterter_Belegtext: "Erweiterter_Belegtext",
      IBAN: "IBAN",
      SWIFT_Code: "SWIFT_Code",
      Name: "Name",
      Post_Code: "Post_Code",
      City: "City",
      Adress: "Adress",
      Posting_Description: "Posting_Description",
      CustProp1: "CustProp1",
      CustProp2: "CustProp2",
      CustProp3: "CustProp3",
      CustProp4: "CustProp4",
      CustProp5: "CustProp5",
      Payment_Terms_Code: "Payment_Terms_Code",
      Payment_Discount_Percent: "Payment_Discount_Percent",
      Pmt_Discount_Date: "Pmt_Discount_Date",
      Zahlungsart: "Zahlungsart",
      Bankzahlungsart: "Bankzahlungsart",
      BankkontoCode: "BankkontoCode",
      Bankleitzahlcode: "Bankleitzahlcode",
      Bankkontonummer: "Bankkontonummer",
      Kontoinhaber: "Kontoinhaber",
      Gemeindenr: "Gemeindenr",
      Gemeinde: "Gemeinde",
      CurrentWorkflowPart_Name: "CurrentWorkflowPart_Name",
      CurrentWorkflowStep_Name: "CurrentWorkflowStep_Name",
      Adressnummer: "Adressnummer",
      Mandatsreferenz_ext_Verfahren: "Mandatsreferenz_ext_Verfahren",
      Unterschrift_Mandat_ext_Verf: "Unterschrift_Mandat_ext_Verf",
      Mandatsreferenz: "Mandatsreferenz",
      Amount: "Amount",
      Amount_Including_VAT: "Amount_Including_VAT",
      LastChanged: "LastChanged",
      LastChangedBy: "LastChangedBy",
      DocumentType: "DocumentType",
      EntryNo: "EntryNo",
      LastStepCode: "LastStepCode",
      LastStepName: "LastStepName",
      SupDocsCount: "SupDocsCount",
      Payment_Method_Code: "Payment_Method_Code",
      Responsibility_Center: "Responsibility_Center",
      CurrentBreakout: "CurrentBreakout",
      ActionType: "ActionType",
      Remark: "Remark",
      ForwardingComment: "ForwardingComment",
      Haushaltsjahr: "Haushaltsjahr",
    },
  },
  FDRW_Workflow_Invoice_Ledger: {
    PageName: "FDRW_Workflow_Invoice_Ledger",
    Fields: {
      LastStepName: "LastStepName",
      CurrentWorkflowStep_Name: "CurrentWorkflowStep_Name",
      CurrentWorkflowPart_Name: "CurrentWorkflowPart_Name",
      CurrentBreakout: "CurrentBreakout",
      SupDocsCount: "SupDocsCount",
      MainDocExists: "MainDocExists",
      Gemeinde: "Gemeinde",
      ID: "ID",
      CheckedOutBy: "CheckedOutBy",
      CheckedOutSince: "CheckedOutSince",
      CurrentWorkflowUser: "CurrentWorkflowUser",
      CurrentWorkflowPart: "CurrentWorkflowPart",
      CurrentWorkflowStep: "CurrentWorkflowStep",
      LastStatusInfo: "LastStatusInfo",
      Created: "Created",
      LastStatusChange: "LastStatusChange",
      Receipt_Date: "Receipt_Date",
      VendorCustomerNo: "VendorCustomerNo",
      DocumentType: "DocumentType",
      Document_Date: "Document_Date",
      Due_Date: "Due_Date",
      Posting_Date: "Posting_Date",
      External_Document_No: "External_Document_No",
      Allocation_Template: "Allocation_Template",
      Document_No: "Document_No",
      Order_No: "Order_No",
      Accounting: "Accounting",
      Erweiterter_Belegtext: "Erweiterter_Belegtext",
      IBAN: "IBAN",
      SWIFT_Code: "SWIFT_Code",
      Search_Name: "Search_Name",
      Name_2: "Name_2",
      Name: "Name",
      Post_Code: "Post_Code",
      Adress: "Adress",
      City: "City",
      Posting_Description: "Posting_Description",
      CustProp1: "CustProp1",
      CustProp2: "CustProp2",
      CustProp3: "CustProp3",
      CustProp4: "CustProp4",
      CustProp5: "CustProp5",
      Payment_Terms_Code: "Payment_Terms_Code",
      Payment_Discount: "Payment_Discount",
      Pmt_Discount_Date: "Pmt_Discount_Date",
      Amount: "Amount",
      Amount_Including_VAT: "Amount_Including_VAT",
      Payment_Method_Code: "Payment_Method_Code",
      LastChanged: "LastChanged",
      LastChangedBy: "LastChangedBy",
      EntryNo: "EntryNo",
      Responsibility_Center: "Responsibility_Center",
      AccountingMode: "AccountingMode",
      Zahlungsart: "Zahlungsart",
      Bankzahlungsart: "Bankzahlungsart",
      BankkontoCode: "BankkontoCode",
      Bankleitzahlcode: "Bankleitzahlcode",
      Bankkontonummer: "Bankkontonummer",
      Kontoinhaber: "Kontoinhaber",
      Adressnummer: "Adressnummer",
      Gemeindenr: "Gemeindenr",
      Mandatsreferenz_ext_Verfahren: "Mandatsreferenz_ext_Verfahren",
      Unterschrift_Mandat_ext_Verf: "Unterschrift_Mandat_ext_Verf",
      Mandatsreferenz: "Mandatsreferenz",
      Haushaltsjahr: "Haushaltsjahr",
      VAT_Reporting_Date: "VAT_Reporting_Date",
      LastStepCode: "LastStepCode",
      ActionType: "ActionType",
      Remark: "Remark",
      ForwardingComment: "ForwardingComment",
      WorkflowType: "WorkflowType",
      WorkflowTypeDescription: "WorkflowTypeDescription",
      View: "View"
    },
  },
  FDRW_Workflow_Users: {
    PageName: "FDRW_Workflow_Users",
    Fields: {
      ID: "ID",
      UserName: "UserName",
      UserLocked: "UserLocked",
      LoginDisabled: "LoginDisabled",
    },
  },
  FDRW_Workflow_Breakouts: {
    PageName: "FDRW_Workflow_Breakouts",
    Fields: {
      Code: "Code",
      Description: "Description",
      LookupPageID: "LookupPageID",
      LookupPageName: "LookupPageName",
      EditableAfterCompletion: "EditableAfterCompletion",
      ForwardingForbidden: "ForwardingForbidden",
    },
  },
  FDRW_Workflow_Step_Breakouts: {
    PageName: "FDRW_Workflow_Step_Breakouts",
    Fields: {
      WFStepID: "WFStepID",
      BreakoutCode: "BreakoutCode",
      BreakoutDescription: "BreakoutDescription",
      NextStepPos: "NextStepPos",
      NextStepPosName: "NextStepPosName",
      NextStepNeg: "NextStepNeg",
      NextStepNegName: "NextStepNegName",
      BreakoutServiceName: "BreakoutServiceName",
    },
  },
  FDRW_Workflow_Start: {
    PageName: "FDRW_Workflow_Start",
    Fields: {
      WFPartCode: "WFPartCode",
      WFStepCode: "WFStepCode",
      WorkflowPartName: "WorkflowPartName",
      WorkflowStepName: "WorkflowStepName",
    },
  },
  FDRW_CustomCaption: {
    PageName: "FDRW_CustomCaption",
    Fields: {
      Name: "Name",
      Caption: "Caption",
    },
  },
  FDRW_PurchaseOrder_Search: {
    PageName: "FDRW_PurchaseOrder_Search",
  },
};

export enum Status {
  Init = 0,
  Running = 1,
  Paused = 2,
  Finished = 3,
  Aborted = 4,
  Error = 5,
  Deleted = 6,
}

export enum AccountingMode {
  Doppik = 0,
  Kameral = 1,
  FWF = 2,
}

export enum SelectedActionType {
  Next_step_in_workflow = 0,
  Forward_to_workflow_step = 1,
  Forward_to_step_with_user_selection = 2,
  Forward_to_workflow_part = 3,
  Back_in_workflow = 4,
  Back_in_workflow_with_user_selection = 5,
  Back_to_workflow_part = 6,
  Finish = 7,
  Reset = 8,
  Cancel = 9,
  Back_in_workflow_history = 10,
  Back_in_workflow_history_to_step = 11,
  Back_to_step_with_user_selection = 12,
}

export enum EventType {
  _blank_ = 0,
  Workflow_started = 1,
  Check_Responsibility = 2,
  Document_forwarded = 3,
  AO_Document_generated = 4,
  Signature_assigned = 5,
  Funds_reserved = 6,
  Funds_approval_requested = 7,
  Workflow_completed = 8,
  Workflow_aborted = 9,
  Workflow_reset = 10,
  SupDoc_added = 11,
  SupDoc_deleted = 12,
  Breakout_started = 13,
  Breakout_completed = 14,
  Breakout_cancelled = 15,
  Breakout_reset = 16,
  Reauthenticate = 17,
}

export enum Type {
  functional = 0,
  technical = 1,
}

export enum ActionType {
  Next_step_in_workflow = 0,
  Forward_to_workflow_step = 1,
  Forward_to_step_with_user_selection = 2,
  Forward_to_workflow_part = 3,
  Back_in_workflow = 4,
  Back_in_workflow_with_user_selection = 5,
  Back_to_workflow_part = 6,
  Finish = 7,
  Reset = 8,
  Cancel = 9,
  Back_in_workflow_history = 10,
  Back_in_workflow_history_to_step = 11,
  Back_to_step_with_user_selection = 12,
  _blank_ = 13,
}

export enum Type_10 {
  _blank_ = 0,
  Main_Document = 1,
  SupDoc = 2,
  PaymOrd = 3,
  CapturingInput = 4,
  Tracking = 5,
  VersionTracking = 6,
  tempPaymOrd = 7,
  OriginalMainDocument = 8,
  XMLTracking = 9,
  PDFTracking = 10,
  tempVersionTracking = 11,
  ISMArchiveProperties = 12,
  XInvoice = 13,
}

export enum Einnahme_Ausgabe_47 {
  Einnahme = 0,
  Ausgabe = 1,
}

export enum Forderungsart_19 {
  HF = 0,
  NF = 1,
}

export enum Status_ {
  _blank_ = 0,
  geändert = 1,
  gelöscht = 2,
  Stand_Jahresabschluss = 3,
}

export enum Type_5 {
  _blank_ = 0,
  G_L_Account = 1,
  Item = 2,
  Fixed_Asset = 3,
  Charge_Item = 4,
}

export enum IC_Partner_Ref_Type {
  _blank_ = 0,
  G_L_Account = 1,
  Item = 2,
  Charge_Item = 3,
  Cross_Reference = 4,
  Common_Item_No = 5,
  Vendor_Item_No = 6,
}

export enum Mittelherkunft_5010395 {
  Lfd_HH = 0,
  HH_Rest = 1,
  ÜPL = 2,
  APL = 3,
  HH_Sperre = 4,
  HH_Sperre_auf_HH_Rest = 5,
  _blank_ = 6,
}

export enum FA_Posting_Type_5601 {
  _blank_ = 0,
  Acquisition_Cost = 1,
  Maintenance = 2,
}

export enum Document_Type_6 {
  _blank_ = 0,
  Payment = 1,
  Invoice = 2,
  Credit_Memo = 3,
  Finance_Charge_Memo = 4,
  Reminder = 5,
  Refund = 6,
}

export enum FA_Posting_Type {
  Acquisition_Cost = 0,
  Depreciation = 1,
  Write_Down = 2,
  Appreciation = 3,
  Custom_1 = 4,
  Custom_2 = 5,
  Proceeds_on_Disposal = 6,
  Salvage_Value = 7,
  Gain_Loss = 8,
  Book_Value_on_Disposal = 9,
  Zuschusseingang = 10,
  Zuschussauflösung = 11,
  Eigenkapitalverzinsung = 12,
  Partial_Disposal = 13,
  Scrap = 14,
  Partial_Scrap = 15,
  Book_Value_on_Scrap = 16,
  Wertkorrektur = 17,
}

export enum FA_Posting_Category {
  _blank_ = 0,
  Disposal = 1,
  Bal_Disposal = 2,
  Scrap = 3,
  Bal_Scrap = 4,
  Im_Auswertungszeitraum_verkauft = 5,
  Im_Auswertungszeitraum_angeschafft = 6,
}

export enum Result_on_Disposal {
  _blank_ = 0,
  Gain = 1,
  Loss = 2,
}

export enum Depreciation_Method {
  Straight_Line = 0,
  Declining_Balance_1 = 1,
  Declining_Balance_2 = 2,
  DB1_SL = 3,
  DB2_SL = 4,
  User_Defined = 5,
  Manual = 6,
  Linear_RBW = 7,
}

export enum Gen_Posting_Type_47 {
  _blank_ = 0,
  Purchase = 1,
  Sale = 2,
  Settlement = 3,
}

export enum Bal_Account_Type_51 {
  G_L_Account = 0,
  Customer = 1,
  Vendor = 2,
  Bank_Account = 3,
  Fixed_Asset = 4,
  IC_Partner = 5,
  Employee = 6,
}

export enum Rechnungsart_5010309 {
  _blank_ = 0,
  Rechnung = 1,
  Bescheid = 2,
}

export enum Bankzahlungsart_5010310 {
  _blank_ = 0,
  Einzugsverfahren = 1,
  Abbuchungsverfahren = 2,
}

export enum Mahnart_5010323 {
  privat_rechtlich = 0,
  öffentlich_rechtlich = 1,
}

export enum Erfassungsart {
  _blank_ = 0,
  lfd_Haushaltsjahr = 1,
  Kassenrest = 2,
}

export enum Veranlagungsart {
  Vorauszahlung = 0,
  Abrechnung = 1,
  _blank_ = 2,
}

export enum Forderungsart {
  Hauptforderung = 0,
  Nebenforderung = 1,
}

export enum Internal_Document_Type {
  _blank_ = 0,
  Unbefristete_Niederschlagung = 1,
  Erlass = 2,
  Vollstreckung = 3,
  Stundung = 4,
  Aussetzung = 5,
  Rücklast = 6,
  Gebühr = 7,
  Vorschuss = 8,
  Abzug_Vorschuss = 9,
  Darlehen = 10,
  BelegnrBuchblatt = 11,
  Befristete_Niederschlagung = 12,
  ILV_Ausgleich = 13,
  Belegrate = 14,
}

export enum Source_Type {
  _blank_ = 0,
  Customer = 1,
  Vendor = 2,
  Bank_Account = 3,
  Fixed_Asset = 4,
  IC_Partner = 5,
  Employee = 6,
  GLAccount = 7,
}

export enum FA_Entry_Type {
  _blank_ = 0,
  Fixed_Asset = 1,
  Maintenance = 2,
}

export enum Kontotyp {
  _blank_ = 0,
  Ertrag = 1,
  Aufwand = 2,
  Einzahlung = 3,
  Auszahlung = 4,
  Bilanz_Zugang = 5,
  Bilanz_Abgang = 6,
  Sammelkonto = 7,
  Bestand = 8,
}

export enum Accounting {
  Customer = 0,
  Vendor = 1,
}

export enum Zahlungsart {
  Standard = 0,
  Abschlagszahlung = 1,
  Schlusszahlung = 2,
}

export enum Feststellung {
  _blank_ = 0,
  sachliche_Richtigkeit = 1,
  rechnerische_Richtigkeit = 2,
  sachliche_und_rechnerische_Richtigkeit = 3,
  Anordnung = 4,
  Prüfung = 5,
}

export enum Usage {
  _blank_ = 0,
  Locked = 1,
  Mandatory = 2,
  Unlocked = 3,
}

export enum Document_Type {
  _blank_ = 0,
  Quote = 1,
  Order = 2,
  Invoice = 3,
  Credit_Memo = 4,
  Blanket_Order = 5,
  Return_Order = 6,
}

export enum Accounting_ {
  _blank_ = 0,
  Customer = 1,
  Vendor = 2,
}

export enum Type_ {
  Header = 0,
  Line = 1,
  LUGM = 2,
  Kameral = 3,
  HUELAufteilung = 4,
}

export enum Execute {
  Always = 0,
  Conditional = 1,
  Never = 2,
}

export enum ViewType {
  Editable = 0,
  Locked = 1,
}

export enum PreviewType {
  Standard = 0,
  Browser = 1,
  HTML5 = 2,
  DMSviewer = 3,
  DMSanmerken = 4,
}

export enum Bankzahlungsart {
  _blank_ = 0,
  Einzugsverfahren = 1,
  Abbuchungsverfahren = 4,
}

export enum ActionType_ {
  Next_step_in_workflow = 0,
  Forward_to_workflow_step = 1,
  Forward_to_step_with_user_selection = 2,
  Forward_to_workflow_part = 3,
  Back_in_workflow = 4,
  Back_in_workflow_with_user_selection = 5,
  Back_to_workflow_part = 6,
  Finish = 7,
  Reset = 8,
  Cancel = 9,
  Back_in_workflow_history = 10,
  Back_in_workflow_history_to_step = 11,
  Back_to_step_with_user_selection = 12,
  _blank_ = 24,
}

export interface IRWFPageMap {
  FDRW_WFInstance: IFDRW_WFInstance;
  FDRW_Workflow_Instance_Action_List: IFDRW_Workflow_Instance_Action_List;
  FDRW_Workflow_Field_Used: IFDRW_Workflow_Field_Used;
  FDRW_Workflow_Step_List: IFDRW_Workflow_Step_List;
  FDRW_Workflow_Setup_WS: IFDRW_Workflow_Setup_WS;
  FDRW_WFInstanceCompleted: IFDRW_WFInstanceCompleted;
  FDRW_Workflow_User_Instances_List: IFDRW_Workflow_User_Instances_List;
  FDRW_Workflow_Invoice_Ledger: IFDRW_Workflow_Invoice_Ledger;
  FDDI_WS_Anlagen_Teilverkauf_Daten: IFDDI_WS_Anlagen_Teilverkauf_Daten;
  FDRW_Workflow_Users: IFDRW_Workflow_Users;
  FDRW_Workflow_Breakouts: IFDRW_Workflow_Breakouts;
  FDRW_Workflow_Step_Breakouts: IFDRW_Workflow_Step_Breakouts;
  FDRW_Workflow_Start: IFDRW_Workflow_Start;
  FDRW_CustomCaption: IFDRW_CustomCaption;
  FDRW_Kontierungsvorschlag: IFDRW_Kontierungsvorschlag;
  FDRW_PurchaseOrder_Search: IFDRW_PurchaseOrder_Search;
  FDRW_Wizard: IFDRW_Wizard;
  FDDI_Wizard_Create_New_DMS_Document: IFDDI_Wizard_Create_New_DMS_Document;
  FDDI_DMS_Sales_Document: IFDDI_DMS_Sales_Document;
  FDDI_DMS_Purchase_Document: IFDDI_DMS_Purchase_Document;
  FDRW_WF_Action_Fwd_Comments_List: IFDRW_WF_Action_Fwd_Comments_List;
  FDRW_Workflow_Running_Instances: IFDRW_Workflow_Running_Instances;
  FDRW_Job_Queue_Entry_List: IFDRW_Job_Queue_Entry_List;
  FDRW_WF_User: IFDRW_WF_User;
  FDRW_Anordnungsblatt: IFDRW_Anordnungsblatt;
  FDRW_Auftragsbuchblatt: IFDRW_Auftragsbuchblatt;
  FDRW_Auftrag: IFDRW_Auftrag;
  FDDI_Vertragsübersicht: IFDDI_Vertragsübersicht;
  FDRW_HuelAufteilung: IFDRW_HuelAufteilung;
  FDRW_AdresseKarte: IFDRW_AdresseKarte;
  FDRW_Zusatzdaten_LuGM: IFDRW_Zusatzdaten_LuGM;
  FDDI_Order_Information_Page: IFDDI_Order_Information_Page;
  FDRW_Gebuchte_Auftragspositionen: IFDRW_Gebuchte_Auftragspositionen;
  FDDI_LuGM_Geschäftsvorfälle: IFDDI_LuGM_Geschäftsvorfälle;
  FDRW_Deferral_Schedule: IFDRW_Deferral_Schedule;
  FDRW_PurchaseOrder: IFDRW_PurchaseOrder;
  FDRW_RecentlyPostedInvoice_List: IFDRW_RecentlyPostedInvoice_List;
  FDRW_Sales_Search: IFDRW_Sales_Search;
  FDRW_Purchase_Search: IFDRW_Purchase_Search;
  FDRW_Kam_Kontierungsvorschlag: IFDRW_Kam_Kontierungsvorschlag;
  FDRW_RecentAO_List: IFDRW_RecentAO_List;
  FDRW_Workflow_Additional_Info: IFDRW_Workflow_Additional_Info;
  Workflow_FWF_Type_Descriptions: IWorkflow_FWF_Type_Descriptions;
  Workflow_FWF_Instance_Completed: IWorkflow_FWF_Instance_Completed;
  Workflow_FWF_Types: IWorkflow_FWF_Types;
    FDRW_WF_Instance_Subscriptions : IFDRW_WF_Instance_Subscriptions;
}
declare global {
  /** 'publish' RWF secigic Page Maps */
  export interface INavPageMap extends IRWFPageMap {
  }
}
export type RWFPageMap<T> = Partial<Record<keyof IRWFPageMap, T>>;
export type FDRW_WFInstance = NavPageItem<IFDRW_WFInstance, "FDRW_WFInstance">;
export type FDRW_Workflow_Instance_Action_List = NavPageItem<IFDRW_Workflow_Instance_Action_List, "FDRW_Workflow_Instance_Action_List">;
export type FDRW_Workflow_Field_Used = NavPageItem<IFDRW_Workflow_Field_Used, "FDRW_Workflow_Field_Used">;
export type FDRW_Workflow_Step_List = NavPageItem<IFDRW_Workflow_Step_List, "FDRW_Workflow_Step_List">;
export type FDRW_Workflow_Setup_WS = NavPageItem<IFDRW_Workflow_Setup_WS, "FDRW_Workflow_Setup_WS">;
export type FDRW_WFInstanceCompleted = NavPageItem<IFDRW_WFInstanceCompleted, "FDRW_WFInstanceCompleted">;
export type FDRW_Workflow_User_Instances_List = NavPageItem<IFDRW_Workflow_User_Instances_List, "FDRW_Workflow_User_Instances_List">;
export type FDRW_Workflow_Invoice_Ledger = NavPageItem<IFDRW_Workflow_Invoice_Ledger, "FDRW_Workflow_Invoice_Ledger">;
export type FDDI_WS_Anlagen_Teilverkauf_Daten = NavPageItem<IFDDI_WS_Anlagen_Teilverkauf_Daten, "FDDI_WS_Anlagen_Teilverkauf_Daten">;
export type FDRW_Workflow_Users = NavPageItem<IFDRW_Workflow_Users, "FDRW_Workflow_Users">;
export type FDRW_Workflow_Breakouts = NavPageItem<IFDRW_Workflow_Breakouts, "FDRW_Workflow_Breakouts">;
export type FDRW_Workflow_Step_Breakouts = NavPageItem<IFDRW_Workflow_Step_Breakouts, "FDRW_Workflow_Step_Breakouts">;
export type FDRW_Workflow_Start = NavPageItem<IFDRW_Workflow_Start, "FDRW_Workflow_Start">;
export type FDRW_CustomCaption = NavPageItem<IFDRW_CustomCaption, "FDRW_CustomCaption">;
export type FDRW_Kontierungsvorschlag = NavPageItem<IFDRW_Kontierungsvorschlag, "FDRW_Kontierungsvorschlag">;
export type FDRW_PurchaseOrder_Search = NavPageItem<IFDRW_PurchaseOrder_Search, "FDRW_PurchaseOrder_Search">;
export type FDRW_Wizard = NavPageItem<IFDRW_Wizard, "FDRW_Wizard">;
export type FDDI_Wizard_Create_New_DMS_Document = NavPageItem<IFDDI_Wizard_Create_New_DMS_Document, "FDDI_Wizard_Create_New_DMS_Document">;
export type FDDI_DMS_Sales_Document = NavPageItem<IFDDI_DMS_Sales_Document, "FDDI_DMS_Sales_Document">;
export type FDDI_DMS_Purchase_Document = NavPageItem<IFDDI_DMS_Purchase_Document, "FDDI_DMS_Purchase_Document">;
export type FDRW_WF_Action_Fwd_Comments_List = NavPageItem<IFDRW_WF_Action_Fwd_Comments_List, "FDRW_WF_Action_Fwd_Comments_List">;
export type FDRW_Workflow_Running_Instances = NavPageItem<IFDRW_Workflow_Running_Instances, "FDRW_Workflow_Running_Instances">;
export type FDRW_Job_Queue_Entry_List = NavPageItem<IFDRW_Job_Queue_Entry_List, "FDRW_Job_Queue_Entry_List">;
export type FDRW_WF_User = NavPageItem<IFDRW_WF_User, "FDRW_WF_User">;
export type FDRW_Anordnungsblatt = NavPageItem<IFDRW_Anordnungsblatt, "FDRW_Anordnungsblatt">;
export type FDRW_Auftragsbuchblatt = NavPageItem<IFDRW_Auftragsbuchblatt, "FDRW_Auftragsbuchblatt">;
export type FDRW_Auftrag = NavPageItem<IFDRW_Auftrag, "FDRW_Auftrag">;
export type FDDI_Vertragsübersicht = NavPageItem<IFDDI_Vertragsübersicht, "FDDI_Vertragsübersicht">;
export type FDRW_HuelAufteilung = NavPageItem<IFDRW_HuelAufteilung, "FDRW_HuelAufteilung">;
export type FDRW_AdresseKarte = NavPageItem<IFDRW_AdresseKarte, "FDRW_AdresseKarte">;
export type FDRW_Zusatzdaten_LuGM = NavPageItem<IFDRW_Zusatzdaten_LuGM, "FDRW_Zusatzdaten_LuGM">;
export type FDDI_Order_Information_Page = NavPageItem<IFDDI_Order_Information_Page, "FDDI_Order_Information_Page">;
export type FDRW_Gebuchte_Auftragspositionen = NavPageItem<IFDRW_Gebuchte_Auftragspositionen, "FDRW_Gebuchte_Auftragspositionen">;
export type FDDI_LuGM_Geschäftsvorfälle = NavPageItem<IFDDI_LuGM_Geschäftsvorfälle, "FDDI_LuGM_Geschäftsvorfälle">;
export type FDRW_Deferral_Schedule = NavPageItem<IFDRW_Deferral_Schedule, "FDRW_Deferral_Schedule">;
export type FDRW_PurchaseOrder = NavPageItem<IFDRW_PurchaseOrder, "FDRW_PurchaseOrder">;
export type FDRW_RecentlyPostedInvoice_List = NavPageItem<IFDRW_RecentlyPostedInvoice_List, "FDRW_RecentlyPostedInvoice_List">;
export type FDRW_Sales_Search = NavPageItem<IFDRW_Sales_Search, "FDRW_Sales_Search">;
export type FDRW_Purchase_Search = NavPageItem<IFDRW_Purchase_Search, "FDRW_Purchase_Search">;
export type FDRW_Kam_Kontierungsvorschlag = NavPageItem<IFDRW_Kam_Kontierungsvorschlag, "FDRW_Kam_Kontierungsvorschlag">;
export type FDRW_RecentAO_List = NavPageItem<IFDRW_RecentAO_List, "FDRW_RecentAO_List">;
export type FDRW_Workflow_Additional_Info = NavPageItem<IFDRW_Workflow_Additional_Info, "FDRW_Workflow_Additional_Info">;
export type Workflow_FWF_Type_Descriptions = NavPageItem<IWorkflow_FWF_Type_Descriptions, "Workflow_FWF_Type_Descriptions">;
export type Workflow_FWF_Instance_Completed = NavPageItem<IWorkflow_FWF_Instance_Completed, "Workflow_FWF_Instance_Completed">;
export type Workflow_FWF_Types = NavPageItem<IWorkflow_FWF_Types, "Workflow_FWF_Types">;
export type RWFPageItem = FDRW_WFInstance | FDRW_Workflow_Instance_Action_List | FDRW_Workflow_Field_Used | FDRW_Workflow_Step_List | FDRW_Workflow_Setup_WS | FDRW_WFInstanceCompleted | FDRW_Workflow_User_Instances_List | FDRW_Workflow_Invoice_Ledger | FDDI_WS_Anlagen_Teilverkauf_Daten | FDRW_Workflow_Users | FDRW_Workflow_Breakouts | FDRW_Workflow_Step_Breakouts | FDRW_Workflow_Start | FDRW_CustomCaption | FDRW_Kontierungsvorschlag | FDRW_PurchaseOrder_Search | FDRW_Wizard | FDDI_Wizard_Create_New_DMS_Document | FDDI_DMS_Sales_Document | FDDI_DMS_Purchase_Document | FDRW_WF_Action_Fwd_Comments_List | FDRW_Workflow_Running_Instances | FDRW_Job_Queue_Entry_List | FDRW_WF_User | FDRW_Anordnungsblatt | FDRW_Auftragsbuchblatt | FDRW_Auftrag | FDDI_Vertragsübersicht | FDRW_HuelAufteilung | FDRW_AdresseKarte | FDRW_Zusatzdaten_LuGM | FDDI_Order_Information_Page | FDRW_Gebuchte_Auftragspositionen | FDDI_LuGM_Geschäftsvorfälle | FDRW_Deferral_Schedule | FDRW_PurchaseOrder | FDRW_RecentlyPostedInvoice_List | FDRW_Sales_Search | FDRW_Purchase_Search | FDRW_Kam_Kontierungsvorschlag | FDRW_RecentAO_List | FDRW_Workflow_Additional_Info | Workflow_FWF_Type_Descriptions | Workflow_FWF_Instance_Completed | Workflow_FWF_Types;
/** Detailled Information about a Single Workflow Intance*/
export interface IFDRW_WFInstance extends IPageObj {
  ID: string;
  IDAsText: string;
  EntryNo: number;
  WorkflowType: string;
  Status: Status;
  PreviousStatus: Status;
  LastStatusInfo: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowPart_Name: string;
  CurrentWorkflowStep: string;
  CurrentWorkflowStep_Name: string;
  CurrentWorkflowUser: string;
  Created: Date;
  LastStatusChange: Date;
  Finished: Date;
  WorkflowConfiguration_No: string;
  WorkflowConfiguration_Name: string;
  Documents: number;
  InitialWorkflowPart: string;
  InitialWorkflowPart_Name: string;
  InitialWorkflowStep: string;
  InitialWorkflowStep_Name: string;
  CheckedOutBy: string;
  CheckedOutSince: Date;
  ReadOnlyView: boolean;
  SignatureEnabled: boolean;
  AccountingMode: AccountingMode;
  ManuallyStarted: boolean;
  SourceRecord: string;
  SourceRecordAsText: string;
  NotificationText?: string;
  SelectedAction: string;
  SelectedActionType: SelectedActionType;
  SelectedAction_Name: string;
  DesiredNextPart: string;
  DesiredNextPart_Name: string;
  DesiredNextStep: string;
  DesiredNextStep_Name: string;
  DesiredNextUser: string;
  FWCommentCode: string;
  Remark: string;
  BreakoutsAvailable: number;
  CurrentBreakout: string;
  Workflow_Log_Entries_Sub: IIAX_WF_Log_Entries_Sub[];
  Workflow_Documents_Sub: IIAX_WF_Documents_Sub[];
  Workflow_Four_Eyes_Journal_Sub: IIAX_WF_Four_Eyes_Journal_Sub[];
  SourceRecordDetails: IIAX_WF_Source_RecordInfo[];
}

export interface IFDRW_Workflow_Instance_Action_List extends IPageObj {
  WFInstanceNo: string;
  No: number;
  WFActionCode: string;
  WFActionName: string;
  WFActionHint: string;
  WFActionType: SelectedActionType;
  WFActionNextStepCode: string;
  WFActionNextStepName: string;
  WFUserID: string;
  WFUserName: string;
  WFActionNextPartCode: string;
  WFActionNextPartName: string;
  RemarkMandatory: boolean;
  Reauthenticate: boolean;
  AVBChooseFile: boolean;
  CheckFunds: boolean;
  ReserveFunds: boolean;
  ActionLocked: boolean;
  ActionLockReason: string;
  SignatureMandatory: boolean;
  FWDCommentMandatory: boolean;
  PaymentOrderCreated: boolean;
  LeaveWizardRequired: boolean;
  CheckHUELAufteilung: boolean;
  ReconciliationTotalRequired: boolean;
  PostingCheckRequired: boolean;
  Feststellung: Feststellung;
}

/**  Used Fields (Mandatory, Readonly)*/
export interface IFDRW_Workflow_Field_Used extends IPageObj {
  Code: string;
  WorkflowStep: string;
  WorkflowStepName: string;
  WorkflowAction: string;
  WorkflowActionName: string;
  Usage: Usage;
  Document_Type: Document_Type;
  Accounting: Accounting_;
  Type: Type_;
  WorkflowFieldAvailable: string;
  DisplayName: string;
  NameOnPageVendor: string;
  NameOnPageCustomer: string;
  NameOnPageWizard: string;
  NameOnPageErfZeileHUEL: string;
}

export interface IFDRW_Workflow_Step_List extends IPageObj {
  Code: string;
  WorkflowPart: string;
  WorkflowPartName: string;
  Sequence_No: number;
  Name: string;
  Description: string;
  Workers: number;
  IL_Workers: number;
  Execute: Execute;
  Conditions: number;
  ViewType: ViewType;
  ValidFrom: Date;
  ValidTo: Date;
  AVBChooseFile: boolean;
  DefaultAction: string;
  DefaultActionName: string;
  ActionAllMandatoriesFilled: string;
  ActionAllMandatoriesFilledName: string;
  MandatoryFields: number;
  LockedFields: number;
  WorkflowActions: number;
  WorkflowEscalations: number;
  WorkflowStepSubscriptions: number;
  WorkflowInstancesStep: number;
  ResolveDistributionLocked: boolean;
  DuplicateLineLocked: boolean;
  InsertNewLineLocked: boolean;
  DeleteLineLocked: boolean;
  ResetWizardLocked: boolean;
  LeaveWizardLocked: boolean;
  AllowWorkflowCopyLocked: boolean;
  BatchProcessingStepDisabled: boolean;
  Created: Date;
  CreatedBy: string;
  LastModified: Date;
  LastModifiedBy: string;
}

/**Workflow Configuration*/
export interface IFDRW_Workflow_Setup_WS extends IPageObj {
  Primary_Key: string;
  LuGMEnabled: boolean;
  SupDocEnabled: boolean;
  InvoiceLedgerPermissonEnabled: boolean;
  CriticalDuration: number;
  CriticalDue: number;
  CriticalAmount: number;
  SignatureEnabled: boolean;
  SignatureSerialNoMandatory: boolean;
  SignatureEnabledOnMainDocument: boolean;
  SystemIndicatorText: string;
  Version: string;
  VersionDate: Date;
  SystemIndicatorStyle: number;
  PreviewType: PreviewType;
  AccountingMode: number;
  ConfigurationName: string;
  IsBWFActive: boolean;
  IsHUELAufteilungActive: boolean;
  IsSplittungsringActive: boolean;
  IsEInvoiceManagerActive: boolean;
  ReconciliationTotalEnabled: boolean;
  ClientCredentialType: string;
  NAVWebClientURL: string;
  IsAnnotationLicensed: boolean;
  IsFWFActive: boolean;
  BatchProcessingEnabled: boolean;
  AllowWorkflowCopy?: boolean;
  Release: string;
}

/**Completed Workflow Info*/
export interface IFDRW_WFInstanceCompleted extends IPageObj {
  ID: string;
  IDAsText: string;
  EntryNo: number;
  WorkflowType: string;
  LastChanged: Date;
  LastChangedBy: string;
  Created: Date;
  Finished: Date;
  WorkflowConfiguration_No: string;
  WorkflowConfiguration_Name: string;
  Documents: number;
  CurrentWorkflowPart: string;
  CurrentWorkflowStep: string;
  InitialWorkflowPart: string;
  InitialWorkflowStep: string;
  CurrentWorkflowPart_Name: string;
  CurrentWorkflowStep_Name: string;
  InitialWorkflowPart_Name: string;
  InitialWorkflowStep_Name: string;
  StorageProvider: string;
  TransactionNoFilter: string;
  AccountingMode: AccountingMode;
  ManuallyStarted: boolean;
  Workflow_Log_Entries_Cpl_Sub: IIAX_WF_Log_Entries_Cpl_Sub[];
  Workflow_Archive_Document_Sub: IIAX_WF_Archive_Document_Sub[];
  WF_GL_Entry_Subpage: IIAX_WF_GL_Entry_Subpage[];
  WF_CL_Entry_Subpage: IIAX_WF_CL_Entry_Subpage[];
  WF_VL_Entry_Subpage: IIAX_WF_VL_Entry_Subpage[];
  WF_FA_Entry_Subpage: IIAX_WF_FA_Entry_Subpage[];
  RegPurchOrderLinesSub: IIAX_Purchase_Order_Subform_Reg[];
  SourceRecordDetails: IIAX_WF_Source_RecordInfo[];
  // do not use, will be mepty in ws context ! Workflow_Add_Information: IIAX_WF_Add_Information_Sub[];
  WF_PK_Entry_Subpage: IIAX_WF_PK_Entry_Subpage[];
  WF_HHST_Entry_Subpage: IIAX_WF_HHST_Entry_Subpage[];
}

/** Information about WF Instance (for Detailled View: my Invoices)*/
export interface IFDRW_Workflow_User_Instances_List extends IPageObj {
  ID: string;
  CheckedOutBy: string;
  CheckedOutSince: Date;
  CurrentWorkflowUser: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowStep: string;
  LastStatusInfo: string;
  Created: Date;
  LastStatusChange: Date;
  Receipt_Date: Date;
  VendorCustomerNo: string;
  Document_Date: Date;
  Due_Date: Date;
  Posting_Date: Date;
  External_Document_No: string;
  Allocation_Template: string;
  Document_No: string;
  Order_No: string;
  Accounting: Accounting;
  Erweiterter_Belegtext: string;
  IBAN: string;
  SWIFT_Code: string;
  Name: string;
  Post_Code: string;
  City: string;
  Adress: string;
  Posting_Description: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Payment_Terms_Code: string;
  Payment_Discount_Percent: number;
  Pmt_Discount_Date: Date;
  Zahlungsart: Zahlungsart;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Kontoinhaber: string;
  Gemeindenr: string;
  Gemeinde: string;
  CurrentWorkflowPart_Name: string;
  CurrentWorkflowStep_Name: string;
  Adressnummer: string;
  Mandatsreferenz_ext_Verfahren: string;
  Unterschrift_Mandat_ext_Verf: Date;
  Mandatsreferenz: string;
  Amount: number;
  Amount_Including_VAT: number;
  LastChanged: Date;
  LastChangedBy: string;
  DocumentType: string;
  EntryNo: number;
  LastStepCode: string;
  LastStepName: string;
  SupDocsCount: number;
  Payment_Method_Code: string;
  Responsibility_Center: string;
  CurrentBreakout: string;
  ActionType: ActionType;
  Remark: string;
  ForwardingComment: string;
  Haushaltsjahr: number;
    FWFData? : IFWFData[];
}

/** Information about WF Instance (for Detailled View: all Invoices)
  * SQL Direct Only!*/
export interface IFDRW_Workflow_Invoice_Ledger extends IPageObj {
  LastStepName: string;
  CurrentWorkflowStep_Name: string;
  CurrentWorkflowPart_Name: string;
  CurrentBreakout: string;
  SupDocsCount: number;
  MainDocExists: boolean;
  Gemeinde: string;
  ID: string;
  CheckedOutBy: string;
  CheckedOutSince: Date;
  CurrentWorkflowUser: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowStep: string;
  LastStatusInfo: string;
  Created: Date;
  LastStatusChange: Date;
  Receipt_Date: Date;
  VendorCustomerNo: string;
  DocumentType: string;
  Document_Date: Date;
  Due_Date: Date;
  Posting_Date: Date;
  External_Document_No: string;
  Allocation_Template: string;
  Document_No: string;
  Order_No: string;
  Accounting: Accounting;
  Erweiterter_Belegtext: string;
  IBAN: string;
  SWIFT_Code: string;
  Search_Name: string;
  Name_2: string;
  Name: string;
  Post_Code: string;
  Adress: string;
  City: string;
  Posting_Description: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Payment_Terms_Code: string;
  Payment_Discount: number;
  Pmt_Discount_Date: Date;
  Amount: number;
  Amount_Including_VAT: number;
  Payment_Method_Code: string;
  LastChanged: Date;
  LastChangedBy: string;
  EntryNo: number;
  Responsibility_Center: string;
  AccountingMode: AccountingMode;
  Zahlungsart: Zahlungsart;
  Bankzahlungsart: Bankzahlungsart;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Kontoinhaber: string;
  Adressnummer: string;
  Gemeindenr: string;
  Mandatsreferenz_ext_Verfahren: string;
  Unterschrift_Mandat_ext_Verf: Date;
  Mandatsreferenz: string;
  Haushaltsjahr: number;
  MwStDatum: Date;
  LastStepCode: string;
  ActionType: ActionType_;
  Remark: string;
  ForwardingComment: string;
  WorkflowType: string;
  WorkflowTypeDescription: string;
  View: string;
}

/**Teilabgang Daten*/
export interface IFDDI_WS_Anlagen_Teilverkauf_Daten extends IPageObj {
  No_Series: string;
  Partial_Disposal_Amount: number;
  Partial_Disposal_Percent: number;
  Partial_Disposal_Quantity: number;
  ToAverage: boolean;
  Price: number;
  IsDepreciated: boolean;
  SammelpostenAbgang: boolean;
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5 |/**Stundung*/6;
  Document_No: string;
  Line_No: number;
  Table_ID: number;
}

/**Liste Aller Workflow Benutzer (Props 'security trimmed' on server side)*/
export interface IFDRW_Workflow_Users extends IPageObj {
  ID: string;
  UserName: string;
  UserLocked: boolean;
  LoginDisabled: boolean;
}

/**FDRW_Workflow_Users*/
export interface IFDRW_Workflow_Breakouts extends IPageObj {
  Code: string;
  Description: string;
  LookupPageID: number;
  LookupPageName: string;
  EditableAfterCompletion: boolean;
  ForwardingForbidden: boolean;
}

/**FDRW_Workflow_Step_Breakouts*/
export interface IFDRW_Workflow_Step_Breakouts extends IPageObj {
  WFStepID: string;
  BreakoutCode: string;
  BreakoutDescription: string;
  NextStepPos: string;
  NextStepPosName: string;
  NextStepNeg: string;
  NextStepNegName: string;
  BreakoutServiceName: string;
}

/**Neue Workflows Startkonfigurationen*/
export interface IFDRW_Workflow_Start extends IPageObj {
  WFPartCode: string;
  WFStepCode: string;
  WorkflowPartName: string;
  WorkflowStepName: string;
}

/**Explizite Captions*/
export interface IFDRW_CustomCaption extends IPageObj {
  Name: string;
  Caption: string;
}

/**eInvoice Templates*/
export interface IFDRW_Kontierungsvorschlag extends IPageObj {
  Sourcetype: /**InvHistData*/0 |/**Order*/1 |/**AccTemplate*/2 |/**Recently_Posted*/3 |/**CrMemoHistData*/4;
  CountEntries: number;
  Type: Type_5;
  Account_No: string;
  Acc_Description: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Gemeindenr: string;
  Sachkonto_Buch_Gruppe: string;
  Vendor_No: string;
  No: number;
  Investitionsnr: string;
  Investitionsname: string;
  Vorgangsnummer: string;
}

export interface IFDRW_PurchaseOrder_Search extends IPageObj {
  Due_Date: Date;
}

export interface IFDRW_Wizard extends IPageObj {
  GUID: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  AccountingMode: /**Doppik*/0 |/**Kameral*/1;
  Amount_incl_VAT: number;
  Adress: string;
  Adressnr: string;
  Due_Date: Date;
  Posting_Date: Date;
  EinnahmeAusgabe: /**Einnahme_SK*/0 |/**Ausgabe_SK*/1 |/**Einnahme_PK*/2 |/**Ausgabe_PK*/3 |/**Auftrag*/4 |/**Reservierung*/5 |/**Clearing*/6;
  IBAN: string;
  SWIFT_Code: string;
  Posting_Description: string;
  Haushaltsjahr: number;
  Gemeindenr: string;
  External_Document_No: string;
  Document_Date: Date;
  Key_1: number;
  Key_2: number;
  Key_3: string;
  Auftragsnr: string;
  CountAuftrag: number;
  IBANToApply: string;
}

export interface IFDDI_Wizard_Create_New_DMS_Document extends IPageObj {
  GUID: string;
  Accounting: Accounting;
  Creation_Type: /**blank*/0 |/**Allocation_Template*/1 |/**Order_No*/2 |/**Reservation*/3 |/**RecurringDocument*/4 |/**PurchOrderChange*/5;
  Company_Name: string;
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Receipt_Date: Date;
  Document_Date: Date;
  Due_Date: Date;
  Posting_Date: Date;
  External_Document_No: string;
  Allocation_Template: string;
  Order_No: string;
  RecurringDocumentNo: string;
  Buy_from_Vendor_Name: string;
  Buy_from_Post_Code: string;
  Erweiterter_Belegtext: string;
  IBAN: string;
  SWIFT_Code: string;
  Amount_incl_VAT: number;
  Sell_to_Customer_Name: string;
  Sell_to_Post_Code: string;
  Key_1: number;
  Key_2: number;
  Key_3: string;
  Name: string;
  Post_Code: string;
  No: string;
  Adress: string;
  BankkontoCode: string;
  Posting_Description: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Responsibility_Center: string;
  CountOrder: number;
  Gemeindenr: string;
  Payment_Method_Code: string;
  WizardCreationLines: IIAX_Wizrd_Creation_Lines[];
  CustBankAccounts: IIAX_Cust_Bank_Account_Sub[];
  VendBankAccounts: IIAX_Vendor_Bank_Account_Sub[];
}

export interface IFDDI_DMS_Sales_Document extends IPageObj {
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  No: string;
  Sell_to_Customer_No: string;
  Adressnummer: string;
  Sell_to_Customer_Name: string;
  Sell_to_Customer_Name_2: string;
  Sell_to_Name_3: string;
  Sell_to_Address: string;
  Sell_to_Address_2: string;
  Sell_to_Post_Code: string;
  Sell_to_City: string;
  Sell_to_Contact: string;
  Sell_to_Country_Region_Code: string;
  Your_Reference: string;
  Betreff_1: string;
  Posting_Date: Date;
  Order_Date: Date;
  Document_Date: Date;
  Due_Date: Date;
  Gemeindenr: string;
  Gemeinde: string;
  External_Document_No: string;
  Salesperson_Code: string;
  Haushaltsstelle: string;
  Responsibility_Center: string;
  Dokumentenart: /**Normal*/0 |/**Gebühr*/1 |/**Vorschuss*/2 |/**Abzug_Vorschuss*/3;
  Status: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  Verarbeitungsstatus: /**Erfasst*/0 |/**Freigegeben*/1 |/**Zurückgestellt*/2 |/**Gebucht*/3 |/**Teilgebucht*/4 |/**Auf_Freigabeliste*/5;
  Allocation_Template: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Bill_to_Customer_No: string;
  Bill_to_Contact_No: string;
  Bill_to_Name: string;
  Bill_to_Name_2: string;
  Bill_to_Name_3: string;
  Bill_to_Address: string;
  Bill_to_Address_2: string;
  Bill_to_Post_Code: string;
  Bill_to_City: string;
  Bill_to_Contact: string;
  Posting_Description: string;
  SumLines: number;
  WizardTotalAmount: number;
  RemainingAmount: number;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Payment_Terms_Code: string;
  Payment_Discount_Percent: number;
  Pmt_Discount_Date: Date;
  Payment_Method_Code: string;
  Prices_Including_VAT: boolean;
  VAT_Bus_Posting_Group: string;
  Mahnart: /**Privat_rechtlich*/0 |/**Öffentlich_rechtlich*/1;
  Mahnmethodencode: string;
  Budget_No: string;
  Ländercode_Bank: string;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  SWIFT_Code: string;
  Bankkontonummer: string;
  IBAN: string;
  Kontoinhaber: string;
  Mandatsreferenz_Lfd_Nr: number;
  Mandatsreferenz: string;
  Erweiterter_Belegtext: string;
  DocID: string;
  Rechnungsart: /**_blank_*/0 |/**Raten*/1 |/**Wiederkehrend*/2;
  Fälligkeitsformel: string;
  Wiederholungsart: /**_blank_*/0 |/**Fix*/1 |/**Variabel*/2;
  Ablaufdatum: Date;
  Ship_to_Code: string;
  Ship_to_Name: string;
  Ship_to_Name_2: string;
  Ship_to_Address: string;
  Ship_to_Address_2: string;
  Ship_to_Post_Code: string;
  Ship_to_City: string;
  Ship_to_Contact: string;
  Location_Code: string;
  Outbound_Whse_Handling_Time: string;
  Shipment_Method_Code: string;
  Shipping_Agent_Code: string;
  Shipping_Agent_Service_Code: string;
  Shipment_Date: Date;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederung_Ergänzung: string;
  Gruppierung1: string;
  Bezeichnung_Haushaltstelle: string;
  Unterkonto: string;
  Investitionsnr: string;
  Vorabdotierungsnr: string;
  Gruppierung_Ergänzung: string;
  Abgabenart_Verkaufsklasse: string;
  Veranlagungsjahr: number;
  Objektnr: string;
  Vorgang_No: string;
  GetWorkOrderNo: string;
  Interne_Verrechnung: boolean;
  ILV_Kreditor: string;
  ILV_Gemeindenr: string;
  Aufwands_KST: string;
  Aufwands_KST_Name: string;
  Aufwands_KTR: string;
  Aufwands_KTR_Name: string;
  Aufwands_Konto: string;
  Aufwands_Konto_Name: string;
  Unterschrift_Mandat_ext_Verf: Date;
  Applies_to_Doc_Type: Document_Type_6;
  Applies_to_Doc_No: string;
  Correction: boolean;
  Mandatsreferenz_ext_Verfahren: string;
  On_Hold: string;
  SalesLines: IIAX_DMS_Sales_Document_Line[];
  LuGMAddRec: IIAX_LuGM_Zusatzdaten_Line[];
}

export interface IFDDI_DMS_Purchase_Document extends IPageObj {
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  No: string;
  Buy_from_Vendor_No: string;
  Adressnummer: string;
  Buy_from_Vendor_Name: string;
  Buy_from_Vendor_Name_2: string;
  Buy_from_Name_3: string;
  Buy_from_Address: string;
  Buy_from_Address_2: string;
  Buy_from_Post_Code: string;
  Buy_from_City: string;
  Buy_from_Contact: string;
  Buy_from_Country_Region_Code: string;
  VAT_Registration_No: string;
  Status: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  OrderNo: string;
  Verarbeitungsstatus: /**erfasst*/0 |/**freigegeben*/1 |/**zurückgestellt*/2 |/**gebucht*/3 |/**teilgebucht*/4 |/**auf_Freigabeliste*/5;
  ReservedFundings: number;
  Allocation_Template: string;
  Your_Reference: string;
  Posting_Date: Date;
  Document_Date: Date;
  Due_Date: Date;
  Eingangsdatum: Date;
  VAT_Reporting_Date: Date;
  Gemeindenr: string;
  Gemeinde: string;
  Payment_Terms_Code: string;
  Payment_Discount_Percent: number;
  Pmt_Discount_Date: Date;
  RWFPaymentDiscountAmount: number;
  Vendor_Invoice_No: string;
  Vendor_Cr_Memo_No: string;
  Purchaser_Code: string;
  Responsibility_Center: string;
  Reg_Bestellung: string;
  SumLines: number;
  WizardTotalAmount: number;
  RemainingAmount: number;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Creation_Type: number;
  Pay_to_Vendor_No: string;
  Pay_to_Contact_No: string;
  Pay_to_Name: string;
  Pay_to_Name_2: string;
  Pay_to_Name_3: string;
  Pay_to_Address: string;
  Pay_to_Address_2: string;
  Pay_to_Post_Code: string;
  Pay_to_City: string;
  Pay_to_Contact: string;
  Posting_Description: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Payment_Method_Code: string;
  On_Hold: string;
  Prices_Including_VAT: boolean;
  VAT_Bus_Posting_Group: string;
  Ländercode_Bank: string;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  SWIFT_Code: string;
  Bankkontonummer: string;
  IBAN: string;
  Kontoinhaber: string;
  Erweiterter_Belegtext: string;
  DocID: string;
  Rechnungsart: /**_blank_*/0 |/**Raten*/1 |/**Wiederkehrend*/2;
  Fälligkeitsformel: string;
  Wiederholungsart: /**_blank__blank_*/0 |/**fix*/1 |/**variabel*/2;
  Ablaufdatum: Date;
  Ship_to_Name: string;
  Ship_to_Address: string;
  Ship_to_Address_2: string;
  Ship_to_Post_Code: string;
  Ship_to_City: string;
  Ship_to_Contact: string;
  Location_Code: string;
  Shipment_Method_Code: string;
  Expected_Receipt_Date: Date;
  Bauleistung: /**_blank_*/0 |/**keine_Bauleistung*/1 |/**Bauleistung_FB_liegt_vor*/2 |/**Bauleistung_keine_FB_vorhanden*/3 |/**Bauleistung_unter_Bagatellgrenze*/4;
  Freistellungsbescheinigung: number;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederung_Ergänzung: string;
  Gruppierung1: string;
  Bezeichnung_Haushaltstelle: string;
  Unterkonto: string;
  Zahlungsart: Zahlungsart;
  Gruppierung_Ergänzung: string;
  Investitionsnr: string;
  Vorabdotierungsnr: string;
  Abgabenart_Verkaufsklasse: string;
  Objektnr: string;
  Statistikcode: string;
  Vorgang_No: string;
  Erstellt_von: string;
  Erstellt_am: Date;
  Applies_to_Doc_Type: Document_Type_6;
  Applies_to_Doc_No: string;
  Applies_to_ID: string;
  Vendor_Order_No: string;
  Vendor_Shipment_No: string;
  PurchLines: IIAX_DMSPurch_DocumentLine[];
  LuGMAddRec: IIAX_LuGM_Zusatzdaten_Line[];
}

export interface IFDRW_WF_Action_Fwd_Comments_List extends IPageObj {
  WorkflowAction: string;
  WorkflowStep: string;
  WorkflowForwardingComment: string;
  Sequence_No: number;
  Comment: string;
}

export interface IFDRW_Workflow_Running_Instances extends IPageObj {
  ID: string;
  CheckedOutBy: string;
  CheckedOutSince: Date;
  CurrentWorkflowUser: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowStep: string;
  LastStatusInfo: string;
  Created: Date;
  LastStatusChange: Date;
  Receipt_Date: Date;
  VendorCustomerNo: string;
  Document_Date: Date;
  Due_Date: Date;
  Posting_Date: Date;
  External_Document_No: string;
  Allocation_Template: string;
  Document_No: string;
  Order_No: string;
  Accounting: Accounting;
  Erweiterter_Belegtext: string;
  IBAN: string;
  SWIFT_Code: string;
  Search_Name: string;
  Name: string;
  Name_2: string;
  Post_Code: string;
  City: string;
  Adress: string;
  Posting_Description: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
  Payment_Terms_Code: string;
  Payment_Discount_Percent: number;
  Pmt_Discount_Date: Date;
  Zahlungsart: Zahlungsart;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Kontoinhaber: string;
  Gemeindenr: string;
  Gemeinde: string;
  CurrentWorkflowPart_Name: string;
  CurrentWorkflowStep_Name: string;
  Adressnummer: string;
  Mandatsreferenz_ext_Verfahren: string;
  Unterschrift_Mandat_ext_Verf: Date;
  Mandatsreferenz: string;
  Amount: number;
  Amount_Including_VAT: number;
  LastChanged: Date;
  LastChangedBy: string;
  DocumentType: string;
  EntryNo: number;
  LastStepCode: string;
  LastStepName: string;
  MainDocExists: boolean;
  SupDocsCount: number;
  Payment_Method_Code: string;
  Responsibility_Center: string;
  CurrentBreakout: string;
  ActionType: ActionType;
  Remark: string;
  ForwardingComment: string;
  Haushaltsjahr: number;
  MyDocument: boolean;
  InvoiceLegder: boolean;
  Involved: boolean;
  Rechnungsart: /**_blank_*/0 |/**Raten*/1 |/**Wiederkehrend*/2;
  Fälligkeitsformel: string;
  Wiederholungsart: /**_blank__blank_*/0 |/**fix*/1 |/**variabel*/2;
  Ablaufdatum: Date;
  Purchaser_Code: string;
  ProcessRouting: boolean;
  RoutingError: string;
  Your_Reference: string;
  WorkflowType: string;
  AccountingMode: AccountingMode;
  WorkflowTypeDescription: string;
  MwStDatum: Date;
  View: string;
}

export interface IFDRW_Job_Queue_Entry_List extends IPageObj {
  Company: string;
  Status: /**Ready*/0 |/**In_Process*/1 |/**Error*/2 |/**On_Hold*/3 |/**Finished*/4;
  Scheduled: boolean;
  ID: string;
  User_ID: string;
  Last_Ready_State: Date;
  Expiration_Date_Time: Date;
  Earliest_Start_Date_Time: Date;
  Object_Type_to_Run: /**Report*/0 |/**Codeunit*/1;
  Object_ID_to_Run: number;
  Object_Caption_to_Run: string;
  Description: string;
  Starting_Time: Date;
  Ending_Time: Date;
  Job_Queue_Category_Code: string;
  Error_Message: string;
  NavClientLink: string;
}

export interface IFDRW_WF_User extends IPageObj {
  ID: string;
  UserName: string;
  InvoiceLedgerViewAllSteps: boolean;
  CanChooseSubstitute: boolean;
  Supervisor: string;
  Substitutions: number;
  Group_Memberships: number;
  Step_Memberships: number;
  SendNotification: boolean;
  E_Mail: string;
  InternalEmail: string;
  SignatureSerialNumber: string;
  NAVUserName: string;
  IsLuGMUser: boolean;
  DaysUntilPasswordExpires: number;
  ShowPasswordExpiryMessage: boolean;
  IsFWFSearchAllowed: boolean;
}

export interface IFDRW_Anordnungsblatt extends IPageObj {
  Gemeindenr: string;
  Adressnr: string;
  Abgabenart: string;
  Objektnr: string;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Unterkonto: string;
  Bezeichnung: string;
  externes_Rechnungsdatum: Date;
  Fälligkeitsdatum: Date;
  Skontodatum: Date;
  Skonto_Percent: number;
  Betrag: number;
  Vorgangsnr: number;
  MwSt_Code: string;
  MwSt_Percent: number;
  USt_Betrag: number;
  Quotierung_Vorsteuerabzug: number;
  Vorsteuer_Betrag: number;
  Betrag_steuerbereinigt: number;
  Bewirtschaftungsstelle: string;
  Nebenforderungsart: string;
  Buchungstext: string;
  Zahlungscode: string;
  Ländercode_Bank: string;
  BLZ: string;
  SWIFT_Code: string;
  Kontonr: string;
  IBAN: string;
  Mandatsreferenz_Lfd_Nr: number;
  Bank_geändert: /**_blank_*/0 |/**HÜL*/1 |/**Kasse*/2;
  Bank_geändert_durch: string;
  Bank_geändert_am: Date;
  Buchungsdatum: Date;
  Überweisungstext: string;
  Überweisungstext_2: string;
  Überweisungstext_3: string;
  Überweisungstext_4: string;
  Überweisungstext_5: string;
  Freistellungsbescheinigung: number;
  Fallnr: string;
  Anordnungsbefugter: string;
  Sachlich_rechner_richtig: string;
  Geprüft: string;
  Anzahl_Raten: number;
  Fälligkeitsformel: string;
  Dauer_AO: boolean;
  Ablaufdatum_DAO: Date;
  Raten_erstellt: boolean;
  Erfassungsart: /**Lfd_HH_Jahr*/0 |/**HH_Rest*/1 |/**Kassenrest*/2 |/**Ist_Rest*/3;
  Kassenzeichen: string;
  Belegnr: number;
  Veranlagungsjahr: number;
  Sachbearbeiter: string;
  Ein_Aus: Einnahme_Ausgabe_47;
  Amt: string;
  Öffentlich_Privat: /**Öffentlich*/0 |/**Privat*/1 |/**_blank_*/2;
  Mahncode: string;
  Art_der_Fälligkeitsfestsetzung: /**_blank_*/0 |/**verbindlich*/1 |/**unverbindlich*/2;
  Abweichende_Verzugszinsen: number;
  Investitionsnr: string;
  Investitionsteilnr: string;
  Niederschlagungsnr: string;
  Wiederauferleben_befr_Nieder: number;
  Istbetrag: number;
  Zahlweg: string;
  Zahldatum: Date;
  Scheck: boolean;
  Schecknr: string;
  Schwebe_bilden: boolean;
  ZV_Zeile: boolean;
  Menge_KLR: number;
  Bauleistung: /**keine_Bauleistung*/0 |/**Bauleistung_FB_liegt_vor*/1 |/**Bauleistung_keine_FB_vorhanden*/2 |/**Bauleistung_unter_Bagatellgrenze*/3;
  Massnahmennr: string;
  Massnahmengewerk: string;
  Objektcode: string;
  Isttext: string;
  Isttext_2: string;
  Isttext_3: string;
  Isttext_4: string;
  Name: string;
  Name_2: string;
  Name_3: string;
  Strasse: string;
  PLZ: string;
  Ort: string;
  Pfad_für_Dateianhang: string;
  Haushaltsjahr: number;
  HUEL_Aufteilung_vorhanden: boolean;
  Zeilennr: number;
  DokID: string;
  Mietverwaltungdokument: boolean;
  Objekttyp_Mietverwaltung: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mietobjekt*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverwaltung: string;
  Nebenkostenschlüssel: string;
  Nebenkosten_von: Date;
  Nebenkosten_bis: Date;
  Ausrüstungsnr: string;
  Abschlagsart: string;
  Vertragsklasse: /**_blank_*/0 |/**General*/1 |/**EVU*/2 |/**Pacht*/3 |/**Erbbau*/4 |/**Reinigung*/5;
  Vertragsnr: string;
  Reinigungsrevier: string;
  SummeEin: number;
  SummeAus: number;
  SummeEin_SummeAus: number;
}

export interface IFDRW_Auftragsbuchblatt extends IPageObj {
  Auftragsz_Buch_Blatt_Name: string;
  Lfd_Nr: number;
  Auftragsnr: string;
  Auftragsposition_Nr: number;
  Gemeindenr: string;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Bezeichnung_Haushaltsstelle: string;
  Unterkonto: string;
  Erfassungsart: /**Lfd_Haushaltsjahr*/0 |/**Haushaltsrest*/1;
  Planung_auf_VE: boolean;
  Planjahr: number;
  externes_Rechnungsdatum: Date;
  Fälligkeitsdatum: Date;
  Skontodatum: Date;
  Skonto_Percent: number;
  Buchungsdatum: Date;
  Adressnr: string;
  Betrag: number;
  MwSt_Code: string;
  MwSt_Percent: number;
  Quotierung_Vorsteuerabzug: number;
  Vorsteuer_Betrag: number;
  USt_Betrag: number;
  Betrag_steuerbereinigt: number;
  Zahlungsart: /**Abschlagszahlung*/0 |/**Schlußzahlung*/1 |/**nochmalige_Schlußzahlung*/2;
  Zahlungscode: string;
  Ländercode_Bank: string;
  BLZ: string;
  Kontonr: string;
  SWIFT_Code: string;
  IBAN: string;
  Kassenzeichen: string;
  Bauleistung: /**keine_Bauleistung*/0 |/**Bauleistung_FB_liegt_vor*/1 |/**Bauleistung_keine_FB_vorhanden*/2 |/**Bauleistung_unter_Bagatellgrenze*/3;
  Freistellungsbescheinigung: number;
  Überweisungstext: string;
  Überweisungstext_2: string;
  Überweisungstext_3: string;
  Überweisungstext_4: string;
  Überweisungstext_5: string;
  Bewirtschaftungsstelle: string;
  HUEL_Aufteilung_vorhanden: boolean;
  DokID: string;
  Maßnahmenr: string;
  Gewerkenr: string;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4;
  Objektcode: string;
  LuGM_Art: /**Objekt*/0 |/**Ausrüstung*/1;
  Ausrüstungsnr: string;
  Summe: number;
}

export interface IFDRW_Auftrag extends IPageObj {
  Nr: string;
  Auftragstext: string;
  Auftragstext_2: string;
  Art_der_Auftragsvergabe: string;
  Gewerke: string;
  Auftragsdatum: Date;
  Firma: string;
  Firmenname: string;
  Verantwortlich: string;
  NameAuftragsverantwortlicher: string;
  Rahmenauftragscode: string;
  Bewirtschaftungsstelle: string;
  Angelegt_von: string;
  Angelegt_am: Date;
  Geändert_von: string;
  Geändert_am: Date;
  Ausführungsfrist: Date;
  Abschlussdatum: Date;
  Freistellungsbescheinigung: number;
  Gewährleistungen: number;
  Statistikkennzeichen_1: string;
  Statistikkennzeichen_1_Text: string;
  Statistikkennzeichen_2: string;
  Statistikkennzeichen_3: string;
  Statistikkennzeichen_2_Text: string;
  Statistikkennzeichen_3_Text: string;
  DokID: string;
  Lieferung_an_Name: string;
  Lieferung_an_Name_2: string;
  Lieferung_an_Adresse: string;
  Lieferung_an_Adresse_2: string;
  Lieferung_an_Ort: string;
  Lieferung_an_Kontaktperson: string;
  Ihre_Referenz: string;
  Maßnahmendokument: boolean;
  Maßnahmenr: string;
  Maßnahmengewerkenr: string;
  Meldungsnr: string;
  Vorgangsnr: string;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4 |/**_blank_*/5;
  Objektexplorercode: string;
  Vertragsdokument: boolean;
  Vertragsnr: string;
  Reinigungsrevier: string;
  Ausrüstungstyp: /**Objekt*/0 |/**Ausrüstung*/1;
  Ausrüstungsnr: string;
  Objekttyp_Mietverwaltung: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mieteinheit*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverwaltung: string;
  Nebenkostenschlüssel: string;
  Nebenkosten_von: Date;
  Nebenkosten_bis: Date;
  Auftragspositionen_Subform: IIAX_Auftragspositionen_Line[];
}

export interface IFDDI_Vertragsübersicht extends IPageObj {
  Status: /**_blank_*/0 |/**Signed*/1 |/**Canceled*/2;
  Vertragsnr: string;
  Beschreibung: string;
  Beschreibung_2: string;
  Vertragsart: string;
  Vertragsgruppe: /**Verkauf*/0 |/**Einkauf*/1;
  Kreditorennr: string;
  Name: string;
  Name_2: string;
  Debitor_Nr: string;
  Deb_Name: string;
  Deb_Name_2: string;
  Adressnr: string;
  Adresse_Name: string;
  Adresse_Name_2: string;
  Startdatum: Date;
  Ablaufdatum: Date;
  Muendlich: boolean;
  Vertragsklasse: /**Vertrag*/0 |/**Reinigungsvertrag*/1;
  Externe_Vertragsnr: string;
  Letztes_Buchungsdatum: Date;
  Nächstes_Buchungsdatum: Date;
  Telefonnr: string;
  E_Mail: string;
  Gemeindenr: string;
  Sachbearbeiter_Nr: string;
  Sachbearbeiter_Name: string;
}

export interface IFDRW_HuelAufteilung extends IPageObj {
  Buchungsdatum: Date;
  Kostenstelle: string;
  Kostenart: string;
  Kostenträger: string;
  Prozess: string;
  Kostenrechnungsbereich: string;
  Anlagennr: string;
  FA_Posting_Type: /**Acquisition_Cost*/0 |/**Depreciation*/1 |/**Write_Down*/2 |/**Appreciation*/3 |/**Custom_1*/4 |/**Custom_2*/5 |/**Disposal*/6 |/**Maintenance*/7 |/**Salvage_Value*/8 |/**Zuschusseingang*/9 |/**Zuschussauflösung*/10 |/**Eigenkapitalverzinsung*/11 |/**Partial_Disposal*/12 |/**Scrap*/13 |/**Partial_Scrap*/14 |/**Book_Value_On_Scrap*/15;
  AfA_Buchcode: string;
  Fibu_Sollkonto: string;
  Fibu_Habenkonto: string;
  Wert_Bezugsgröße: number;
  Anteil_Percent: number;
  Betrag: number;
  Menge: number;
  Buchungstext: string;
  DokID: string;
  HÜL_Zeilennr: number;
  Lfd_Nr: number;
  KostrechbereichName: string;
  KOAName: string;
  KSTName: string;
  KTRName: string;
}

export interface IFDRW_AdresseKarte extends IPageObj {
  Nr: string;
  Anredecode: string;
  g_Anredetext: string;
  Name: string;
  Name_2: string;
  Name_3: string;
  Strassennr: string;
  Strassenname: string;
  Strassenbezeichnung: string;
  Hausnr: number;
  Hausnrzusatz: string;
  Strassenbezeichnung2: string;
  Ortsteilnr: string;
  Ortsteilname: string;
  PLZ: string;
  Ort: string;
  Laendercode: string;
  Ländercode_Text: string;
  ShowMap: string;
  Suchbegriff: string;
  Aktive_Adresse: boolean;
  Expiring: boolean;
  Anonymized: boolean;
  Einmalzahler: boolean;
  Interne_Adresse: boolean;
  ZusammenfassendeAbbuchung: /**_blank_*/0 |/**Ja*/1 |/**Nein*/2;
  Adressgruppe: string;
  Ext_Adressen_var_Kass: number;
  Ext_Adressen_var_BS: number;
  Payment_Terms_Code: string;
  Wohnanschrift_Str_und_Hausnr: string;
  Wohnanschrift_Str_u_Hausnr_2: string;
  Wohnanschrift_PLZ: string;
  Wohnanschrift_Ort: string;
  WohnanschriftLaendercode: string;
  WohnanschriftLaendercodeText: string;
  Telefonnr: string;
  Mobiltelefonnr: string;
  Faxnr: string;
  E_Mail: string;
  Homepage: string;
  Wohnadresse_drucken: boolean;
  Neue_Adressnr: string;
  unbekannt_verzogen: boolean;
  Insolvenz: boolean;
  Datum_Insolvenzeröffnung: Date;
  IAX_IVM_Send_PDF: boolean;
  IAX_FERO_AllowEInvoice: boolean;
  InsolvenzIntegrationAdresse_AktiveInsolvenzakteVorhanden_Nr: boolean;
  InsolvenzIntegrationAdresse_AbweichendeAdresseInsoAkteVorhanden_Nr: boolean;
  VAT_Registration_No_: string;
  Anzahl_alte_Adressen: number;
  EWO_Ordnungsmerkmal: string;
  Einwohnerregisterzeilen: number;
  kein_Zahlungsavis_drucken: boolean;
  Sammelbescheid_nicht_drucken: boolean;
  Pseudo_Adresse: boolean;
  keine_Mahngebühren_berechnen: boolean;
  Keine_Mahnzinsen_berechnen: boolean;
  Freistellungsbescheinigung: number;
  Wiedervorlage_Adresse: number;
  AnzahlEmpfaengerVon: number;
  Weitere_Eigentümer_von: number;
  Originaldok_nur_an_Adressaten: boolean;
  Person_No: string;
  Person_Type: /**Natural_Person*/0 |/**Legal_Person*/1 |/**Marriage*/2 |/**Person_Community*/3 |/**_blank_*/4;
  Person_Name: string;
  Birth_Date_Person: Date;
  Person_Departed: boolean;
  Date_of_Death_Person: Date;
  Birth_Date_2_Person: Date;
  Person_Departed_2: boolean;
  Date_of_Death_2_Person: Date;
  AddressManagementInterface_CountAllLinkedAddresses_Nr: number;
  Favourite_Address: boolean;
  Synchronize_with_Person: boolean;
  Neue_Schuldnernr: string;
  Anzahl_alte_Schuldner: number;
  Debitorennr: string;
  CustGenBusPostingGroup: string;
  CustomerVATBusPostingGroup: string;
  CustCustomerPostingGroup: string;
  CustFinanzbuchungsgruppe: string;
  CustReminderTermsCode: string;
  CustMahnmethCodeoeffentlich: string;
  CustMahnmethodencodeprivat: string;
  CustZinskondCodeoeffent: string;
  FinChargeTerms: string;
  CustomerCurrencyCode: string;
  CustZlgBedingungscode: string;
  CustZahlungsformcode: string;
  Kreditorennr: string;
  VendorGenBusPostingGroup: string;
  VendorVATBusPostingGroup: string;
  VendorVendorPostingGroup: string;
  VendorFinanzbuchungsgruppe: string;
  VendorFinChargeTermsCode: string;
  VendorZlgBedingungscode: string;
  VendorZahlungsformcode: string;
  VendorCurrencyCode: string;
  VendorDirectionCode: string;
  VendorPaymentType: string;
  Statistikkennzeichen: string;
  Statistikkennzeichen_2: string;
  Statistikkennzeichen_3: string;
  Code1: string;
  Code2: string;
  Text1: string;
  Text2: string;
  Date1: Date;
  Date2: Date;
  Dokumente_Adresse: IIAX_Dokumente_Adresse[];
}

export interface IFDRW_Zusatzdaten_LuGM extends IPageObj {
  Table_ID: number;
  Int1: number;
  Int2: number;
  Code1: string;
  Code2: string;
  Entry_No: number;
  Vertragsnr: string;
  Vertragszeilennr: number;
  Vertragsklasse: /**_blank_*/0 |/**General*/1 |/**EVU*/2 |/**Pacht*/3 |/**Reinigung*/4 |/**Grundstück*/5;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4 |/**_blank_*/5;
  Liegenschaftsnr: string;
  Gebäudenr: string;
  Gebäudeteilnr: string;
  Geschosscode: string;
  Raumcode: string;
  Ausrüstungsnr: string;
  Objektcode: string;
  Objekttyp_Mietverwaltung: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mieteinheit*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverwaltung: string;
  Mietvertragsnr: string;
  Mietvertragszeilennr: number;
  Nebenkostenschlüssel: string;
  Nebenkosten_von: Date;
  Nebenkosten_bis: Date;
  Nebenkostenabrechungsnr: number;
  Maßnahmenr: string;
  Gewerkenr: string;
  Abschlagsart: string;
  Meldungsnummer: string;
  Meldungsvorgangsnummer: string;
  Erbbaurechtsvertragsnr: string;
  Erbbaurechtsvertragszeilennr: number;
  Entry_No_G_L_Entry: number;
  Entry_No_Cust_Legder_Entry: number;
  Entry_No_Vendor_Ledger_Entry: number;
  Zusatz_Table_ID: number;
  Zusatz_Int1: number;
  Zusatz_Int2: number;
  Zusatz_Code1: string;
  Zusatz_Code2: string;
  Amount: number;
  ReverseFromFM: boolean;
  Transaction_No: number;
  Objektbezeichnung: string;
  Maßnahmenr_ILV: string;
  Gewerkenr_ILV: string;
  Vertragsklasse_ILV: /**_blank_*/0 |/**General*/1 |/**EVU*/2 |/**Pacht*/3 |/**Reinigung*/4 |/**Grundstück*/5;
  Vertragsnr_ILV: string;
  Objekttyp_Mietverw_ILV: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mieteinheit*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverw_ILV: string;
  Nebenkostenschlüssel_ILV: string;
  Nebenkosten_von_ILV: Date;
  Nebenkosten_bis_ILV: Date;
  Geschäftsvorfallcode_ILV: string;
  Maßnahmenbuchung_ILV: boolean;
  Vertragsbuchung_ILV: boolean;
  Mietvertragsbuchung_ILV: boolean;
  Reg_No: number;
  Document_Date: Date;
  Ext_Document_No: string;
  Reversed: boolean;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  Int3: number;
  Zusatz_Int3: number;
  Geschäftsvorfallcode: string;
  Maßnahmenbuchung: boolean;
  Meldungsbuchung: boolean;
  Vertragsbuchung: boolean;
  Erbbaurechtsbuchung: boolean;
  Mietvertragsbuchung: boolean;
  Belegart: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Erstellt_am_Verkauf: Date;
  Erstellt_von_Verkauf: string;
  Art_Verkauf: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  Kontonr_Verkauf: string;
  Beschreibung_Verkauf: string;
  Beschreibung_2_Verkauf: string;
  Kostenstelle_Verkauf: string;
  Kostenträger_Verkauf: string;
  Fälligkeitsdatum_Verkauf: Date;
  Buchungsdatum_Verkauf: Date;
  Debitorennr_Verkauf: string;
  Debitorenname_Verkauf: string;
  Erstellt_am_Einkauf: Date;
  Erstellt_von_Einkauf: string;
  Art_Einkauf: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  Kontonr_Einkauf: string;
  Beschreibung_Einkauf: string;
  Beschreibung_2_Einkauf: string;
  Kostenstelle_Einkauf: string;
  Kostenträger_Einkauf: string;
  Fälligkeitsdatum_Einkauf: Date;
  Buchungsdatum_Einkauf: Date;
  Kreditorennr_Einkauf: string;
  Kreditorenname_Einkauf: string;
  Zahlungsart_Einkauf: Zahlungsart;
  Betrag_akt_Rechnung: number;
  Restbetrag: number;
  Bestelldatum_Einkauf: Date;
  Kred_Rechnungsnr_Einkauf: string;
  Kostenstelle_Name_Verkauf: string;
  Kostenträger_Name_Verkauf: string;
  Kostenstelle_Name_Einkauf: string;
  Kostenträger_Name_Einkauf: string;
  Status_Einkauf: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  Status_Verkauf: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  bereits_berechneter_Betrag: number;
  Posting_Descritopn_Sales: string;
  Posting_Descritopn_Purchase: string;
  Allocated_Amount_Purchase: number;
  Line_Amount_Sales: number;
  Line_Amount_Purchase: number;
  Verarbeitungsstatus_Einkauf: /**erfasst*/0 |/**freigegeben*/1 |/**zurückgestellt*/2 |/**gebucht*/3 |/**teilgebucht*/4 |/**auf_Freigabeliste*/5;
  Verarbeitungsstatus_Verkauf: /**Erfasst*/0 |/**Freigegeben*/1 |/**Zurückgestellt*/2 |/**Gebucht*/3 |/**Teilgebucht*/4 |/**Auf_Freigabeliste*/5;
  EVU_AbrechnungsNr: string;
  Debitorennr: string;
  Kreditorennr: string;
  MesspunktNr: string;
  Reinigungsrevier: string;
  Bruttobetrag: number;
  Restbetrag_offen: number;
  Sachkontonr: string;
  Kostenstelle: string;
  Kostenträger: string;
  Zahlbetrag: number;
  Posting_Date: Date;
  DescriptionGLEntry: string;
  Vergabesumme: number;
  Vertragstyp: /**_blank_*/0 |/**Hauptauftrag*/1 |/**Nachtrag*/2 |/**Abruf_Rahmenvertrag*/3 |/**Minderung*/4 |/**Vorsorge*/5;
  davon_zuwendungsfähig: number;
  erwartete_Zuwendung: number;
  erwartete_Weiterbelastung: number;
  Interne_Nr: string;
  Massnahmenbeschreibung: string;
  Gewerkebezeichnung: string;
  Meldungsbezeichnung: string;
  Ausrüstungsbezeichnung: string;
  Vertragsbezeichnung: string;
  Messpunktbeschreibung: string;
  Reinigungsrevierbeschreibung: string;
  Mietvertragsbeschreibung: string;
  Nebenkostenschlüsselbezeichnung: string;
  WFGuid: string;
}

export interface IFDDI_Order_Information_Page extends IPageObj {
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Document_No: string;
  Line_No: number;
  Type: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  No: string;
  Description: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Quantity: number;
  Quantity_Received: number;
  OutstandingQuantity: number;
  QuantityInWF: number;
  Direct_Unit_Cost: number;
  LineDiscountPercent: number;
  LineDiscountAmount: number;
  LineAmount: number;
  Bereits_berechneter_Betrag: number;
  Restbetrag_zur_Fakturierung: number;
  AmountInWF: number;
  Investitionsnr: string;
  Auftragsnummer: string;
  Mittelherkunft: Mittelherkunft_5010395;
  NoOfDocs: number;
  FormatQuantityCritical: boolean;
  FormatAmountCritical: boolean;
  Vorgangsnummer: string;
  WFIDFilterWithRefToCurrentPOLine: string;
}

export interface IFDRW_Gebuchte_Auftragspositionen extends IPageObj {
  Lfd_Nr: number;
  Auftragsnr: string;
  Auftragstext: string;
  Auftragstext_2: string;
  Firma: string;
  Firmenname: string;
  Positionsnr: number;
  Abgangsart: /**_blank_*/0 |/**Korrektur*/1 |/**Übertrag_ins_Folgejahr*/2;
  Gemeindenr: string;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Unterkonto: string;
  Vorgangsnummer: number;
  Erfassungsart: /**Lfd_Haushaltsjahr*/0 |/**Haushaltsrest*/1 |/**Planwert*/2;
  Planung_auf_VE: boolean;
  Planjahr: number;
  Buchungstext: string;
  Buchungstext_2: string;
  Fälligkeitsdatum: Date;
  Bewirtschaftungsstelle: string;
  Abgeschlossen: boolean;
  Auftragspositionen_Details: number;
  Reservierter_Betrag: number;
  MwSt_Code: string;
  gesamt_Reservierter_Betrag: number;
  gesamt_Angeordneter_Betrag: number;
  gesamt_Offener_Betrag: number;
  gesamt_Offener_Betrag_steuerbr: number;
  MwSt_Percent: number;
  USt_Betrag: number;
  Quotierung_Vorsteuerabzug: number;
  Vorsteuer_Betrag: number;
  Maßnahmenr: string;
  Gewerk: string;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4;
  Objektcode: string;
  Ausrüstungsnr: string;
  LuGM_Art: /**Objekt*/0 |/**Ausrüstung*/1;
  Gebucht_am: Date;
  Gebucht_um: Date;
  Gebucht_von: string;
  Geändert_am: Date;
  Geändert_um: Date;
  Geändert_von: string;
  DokID: string;
}

export interface IFDDI_LuGM_Geschäftsvorfälle extends IPageObj {
  Geschäftsvorfallcode: string;
  Beschreibung: string;
  Posting_Type: /**Purchase*/0 |/**Sale*/1 |/**Bilanzausgleich*/2;
  Maßnahmenbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Meldungsbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Vertragsbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Mietbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Erbbaurechtsbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Raumreservierungsbuchung: /**Pflicht*/0 |/**kann*/1 |/**nicht_zulässig*/2;
  Dimensionspriorität: string;
}

export interface IFDRW_Deferral_Schedule extends IPageObj {
  Amount_to_Defer: number;
  Calc_Method: /**Straight_Line*/0 |/**Equal_per_Period*/1 |/**Days_per_Period*/2 |/**User_Defined*/3;
  No_of_Periods: number;
  PostingDate: Date;
  StartDateCalcMethod: string;
  Start_Date: Date;
  Deferral_Doc_Type: /**Purchase*/0 |/**Sales*/1 |/**G_L*/2;
  Gen_Jnl_Template_Name: string;
  Gen_Jnl_Batch_Name: string;
  Document_Type: number;
  Document_No: string;
  Line_No: number;
  DeferralSheduleSubform: IDeferral_Schedule_Line[];
}

export interface IFDRW_PurchaseOrder extends IPageObj {
  No: string;
  Buy_from_Vendor_No: string;
  Buy_from_Vendor_Name: string;
  Buy_from_Address: string;
  Adressnummer: string;
  Buy_from_Address_2: string;
  Buy_from_Post_Code: string;
  Buy_from_City: string;
  Buy_from_County: string;
  Buy_from_Country_Region_Code: string;
  Buy_from_Contact_No: string;
  Buy_from_Contact: string;
  BuyFromContactPhoneNo: string;
  BuyFromContactMobilePhoneNo: string;
  BuyFromContactEmail: string;
  Zahlungsart: Zahlungsart;
  Reservierte_Mittel: number;
  Erstellt_am: Date;
  Erstellt_von: string;
  Posting_Date: Date;
  Order_Date: Date;
  Document_Date: Date;
  Due_Date: Date;
  Eingangsdatum: Date;
  MwStDatum: Date;
  Gemeindenr: string;
  Vendor_Order_No: string;
  Vendor_Shipment_No: string;
  Vendor_Invoice_No: string;
  Order_Address_Code: string;
  Purchaser_Code: string;
  Assigned_User_ID: string;
  Erweiterter_Belegtext: string;
  DocID: string;
  Responsibility_Center: string;
  Payment_Terms_Code: string;
  Status: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  Verarbeitungsstatus: /**erfasst*/0 |/**freigegeben*/1 |/**zurückgestellt*/2 |/**gebucht*/3 |/**teilgebucht*/4 |/**auf_Freigabeliste*/5;
  Job_Queue_Status: /**_blank_*/0 |/**Scheduled_for_Posting*/1 |/**Error*/2 |/**Posting*/3;
  DocumentAmount: number;
  RestOfAmount: number;
  Quote_No: string;
  Prices_Including_VAT: boolean;
  VAT_Bus_Posting_Group: string;
  Posting_Description: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Payment_Method_Code: string;
  Transaction_Type: string;
  Pmt_Discount_Date: Date;
  Payment_Discount_Percent: number;
  Payment_Disc_Amount: number;
  Tax_Liable: boolean;
  Tax_Area_Code: string;
  On_Hold: string;
  Posting_No: string;
  No_of_Archived_Versions: number;
  Pay_to_Vendor_No: string;
  Pay_to_Name: string;
  Pay_to_Address: string;
  Pay_to_Address_2: string;
  Pay_to_Post_Code: string;
  Pay_to_City: string;
  Pay_to_County: string;
  Pay_to_Country_Region_Code: string;
  Pay_to_Contact_No: string;
  Pay_to_Contact: string;
  PayToContactPhoneNo: string;
  PayToContactMobilePhoneNo: string;
  PayToContactEmail: string;
  BankkontoCode: string;
  Ländercode_Bank: string;
  Bankzahlungsart: Bankzahlungsart_5010310;
  Bankleitzahlcode: string;
  SWIFT_Code: string;
  IBAN: string;
  Kontoinhaber: string;
  Bankkontonummer: string;
  Payment_Reference: string;
  Creditor_No: string;
  Ship_to_Code: string;
  Ship_to_Name: string;
  Ship_to_Name_2: string;
  Ship_to_Address: string;
  Ship_to_Address_2: string;
  Ship_to_Post_Code: string;
  Ship_to_City: string;
  Ship_to_County: string;
  Ship_to_Country_Region_Code: string;
  Ship_to_Contact: string;
  Shipment_Method_Code: string;
  Location_Code: string;
  Sell_to_Customer_No: string;
  Expected_Receipt_Date: Date;
  Inbound_Whse_Handling_Time: string;
  Lead_Time_Calculation: string;
  Requested_Receipt_Date: Date;
  Promised_Receipt_Date: Date;
  Currency_Code: string;
  Transaction_Specification: string;
  Transport_Method: string;
  Entry_Point: string;
  Area: string;
  Haushaltsjahr: number;
  Abgabenart_Verkaufsklasse: string;
  Objektnr: string;
  Vorgang_No: string;
  Haushalt: string;
  Gliederung: string;
  Gliederung_Ergänzung: string;
  Gruppierung1: string;
  Gruppierung_Ergänzung: string;
  Bezeichnung_Haushaltstelle: string;
  Unterkonto: string;
  Bauleistung: /**_blank_*/0 |/**keine_Bauleistung*/1 |/**Bauleistung_FB_liegt_vor*/2 |/**Bauleistung_keine_FB_vorhanden*/3 |/**Bauleistung_unter_Bagatellgrenze*/4;
  Freistellungsbescheinigung: number;
  Verpf_Ermächtigungsnr: string;
  Investitionsnr: string;
  Vorabdotierungsnr: string;
  Kam_Auftragsnummer: string;
  Statistikcode: string;
  Prepayment_Percent: number;
  Compress_Prepayment: boolean;
  Prepmt_Payment_Terms_Code: string;
  Prepayment_Due_Date: Date;
  Prepmt_Payment_Discount_Percent: number;
  Prepmt_Pmt_Discount_Date: Date;
  Vendor_Cr_Memo_No: string;
  PurchLines: IPurchase_Order_Line[];
}

export interface IFDRW_RecentlyPostedInvoice_List extends IPageObj {
  Type: Type_5;
  CountEntries: number;
  Account_No: string;
  Acc_Description: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Gemeindenr: string;
  Sachkonto_Buch_Gruppe: string;
  Vendor_No: string;
  Num: number;
  Investitionsnr: string;
  Investitionsname: string;
  Vorgangsnummer: string;
}

export interface IFDRW_Sales_Search extends IPageObj {
  Entry_No: number;
  G_L_Account_No: string;
  G_L_Account_Name: string;
  Kontotyp: Kontotyp;
  Description: string;
  Amount: number;
  Global_Dimension_1_Code: string;
  Global_Dimension_1_Name: string;
  Global_Dimension_2_Code: string;
  Global_Dimension_2_Name: string;
  System_Created_Entry: boolean;
  Quantity: number;
  VAT_Amount: number;
  Transaction_No: number;
  VAT_Prod_Posting_Group: string;
  Reversed: boolean;
  FA_Entry_Type: FA_Entry_Type;
  FA_Entry_No: number;
  CLE_No: number;
  Posting_Date: Date;
  Document_Type: Document_Type_6;
  Document_No: string;
  CLE_Description: string;
  Sell_to_Customer_No: string;
  Debitorenname: string;
  Salesperson_Code: string;
  User_ID: string;
  Open: boolean;
  Due_Date: Date;
  Pmt_Discount_Date: Date;
  Reason_Code: string;
  Document_Date: Date;
  External_Document_No: string;
  Erweiterter_Belegtext: string;
  WorkflowID: string;
  WFEntryNo: number;
  RemainingAmount: number;
  Mahnmethodencode: string;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Zahlungsformcode: string;
  Kontoinhaber: string;
  Mahnart: Mahnart_5010323;
  IBAN: string;
  SWIFT_Code: string;
  Investitionsnr: string;
  Adressnr: string;
  Objektnummer: string;
  Abgabenart_Objekt: string;
  Abgabenart_Verkaufsklasse: string;
  Abgabenart_Name: string;
  Gemeindenr: string;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Strasse_Adresse: string;
  PLZ_Adresse: string;
  Ort_Adresse: string;
  Vorgang_No: string;
  Berechtigungscode: string;
  SupDocsCount: number;
  DocumentTotalAmount: number;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
}

export interface IFDRW_Purchase_Search extends IPageObj {
  Entry_No: number;
  Kontotyp: Kontotyp;
  G_L_Account_No: string;
  G_L_Account_Name: string;
  Description: string;
  Amount: number;
  Global_Dimension_1_Code: string;
  Global_Dimension_1_Name: string;
  Global_Dimension_2_Code: string;
  Global_Dimension_2_Name: string;
  System_Created_Entry: boolean;
  Quantity: number;
  VAT_Amount: number;
  Transaction_No: number;
  VAT_Prod_Posting_Group: string;
  Reversed: boolean;
  FA_Entry_Type: FA_Entry_Type;
  FA_Entry_No: number;
  VLE_No: number;
  Posting_Date: Date;
  Document_Type: Document_Type_6;
  Document_No: string;
  VLE_Description: string;
  Description_2: string;
  Buy_from_Vendor_No: string;
  Kreditorenname: string;
  Purchaser_Code: string;
  User_ID: string;
  Open: boolean;
  Due_Date: Date;
  Pmt_Discount_Date: Date;
  Reason_Code: string;
  Document_Date: Date;
  External_Document_No: string;
  Erweiterter_Belegtext: string;
  WorkflowID: string;
  WFEntryNo: number;
  RemainingAmount: number;
  Mahnmethodencode: string;
  Eingangsdatum: Date;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Zahlungsformcode: string;
  Kontoinhaber: string;
  Mahnart: Mahnart_5010323;
  IBAN: string;
  SWIFT_Code: string;
  Investitionsnr: string;
  Adressnr: string;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Objektnummer: string;
  Abgabenart_Objekt: string;
  Abgabenart_Verkaufsklasse: string;
  Gemeindenr: string;
  Mittelherkunft: Mittelherkunft_5010395;
  Vorgang_No: string;
  Berechtigungscode: string;
  SupDocsCount: number;
  DocumentTotalAmount: number;
  MwStDatum: Date;
  OrderNo: string;
  CustProp1: string;
  CustProp2: string;
  CustProp3: string;
  CustProp4: string;
  CustProp5: string;
}

export interface IFDRW_Kam_Kontierungsvorschlag extends IPageObj {
  Count: number;
  Type: /**Personenkontoposten*/0 |/**Haushaltsstellenposten*/1;
  HHJahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Unterkonto: string;
  Address_No: string;
  No: number;
}

export interface IFDRW_RecentAO_List extends IPageObj {
  Count: number;
  Type: /**Personenkontoposten*/0 |/**Haushaltsstellenposten*/1;
  HHJahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Unterkonto: string;
  Address_No: string;
  No: number;
  Num: number;
}

export interface IFDRW_Workflow_Additional_Info extends IPageObj {
  WFInstanceNo: string;
  Key1: string;
  DocumentNo: string;
  Description: string;
  TextValue: string;
}

/**SQL Direct Only!*/
export interface IWorkflow_FWF_Type_Descriptions extends IPageObj {
  TypeID: string;
  MaindataTableID: number;
  FieldID: number;
  FieldName: string;
  FieldCaption: string;
  FieldType: string;
  FieldOptionCaption: string;
  FieldLength: number;
  InitialVisible: boolean;
}

/**SQL Direct Only!*/
export interface IWorkflow_FWF_Instance_Completed extends IPageObj {
  WorkflowID: string;
  TypeID: string;
  EntryNo: number;
  Created: Date;
  Finished: Date;
  IsArchived: boolean;
  FWFData: IFWFData[];
  MainDocExists: boolean;
  SupDocsCount: number;
}

export interface IFDRW_WF_Instance_Subscriptions extends IPageObj {
  Workflowbenutzer : string;
  Workflowinstanz: string;
}

/**SQL Direct Only!*/
export interface IWorkflow_FWF_Types extends IPageObj {
  ID: string;
  Enabled: boolean;
  Description: string;
  Area: string;
  ShowRequestPage: boolean;
  MainTableID: number;
}

export interface IIAX_WF_Log_Entries_Sub extends IPageObj {
  WFInstanceNo: string;
  EntryNo: number;
  Created: Date;
  EventType: EventType;
  Type: Type;
  Description: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowPartName: string;
  CurrentWorkflowStep: string;
  CurrentWorkflowStepName: string;
  CurrentWFUser: string;
  CurrentWFUserName: string;
  Action: string;
  ActionName: string;
  ActionType: ActionType;
  NextWorkflowPart: string;
  NextWorkflowPartName: string;
  NextWorkflowStep: string;
  NextWorkflowStepName: string;
  NextWFUser: string;
  NextWFUserName: string;
  Remark: string;
  ForwardingComment: string;
}

export interface IIAX_WF_Documents_Sub extends IPageObj {
  ID: string;
  WorkflowInstanceID: string;
  Type: Type_10;
  Description: string;
  Added: Date;
  AddedBy: string;
  Extension: string;
  Sealed: boolean;
}

export interface IIAX_WF_Four_Eyes_Journal_Sub extends IPageObj {
  WFInstanceNo: string;
  WorkflowPart: string;
  WorkflowPartName: string;
  WorkflowStep: string;
  WorkflowStepName: string;
  WorkflowUser: string;
  WorkflowAction: string;
  WorkflowActionName: string;
  Created: Date;
}

export interface IIAX_WF_Source_RecordInfo extends IPageObj {
  SourceRecordAsText: string;
  Name: string;
  Value: string;
}

export interface IIAX_WF_Log_Entries_Cpl_Sub extends IPageObj {
  WFInstanceNo: string;
  EntryNo: number;
  Created: Date;
  EventType: EventType;
  Type: Type;
  Description: string;
  CurrentWFUser: string;
  CurrentWFUserName: string;
  CurrentWorkflowPart: string;
  CurrentWorkflowPartName: string;
  CurrentWorkflowStep: string;
  CurrentWorkflowStepName: string;
  Action: string;
  ActionName: string;
  NextWorkflowPart: string;
  NextWorkflowPartName: string;
  NextWorkflowStep: string;
  NextWorkflowStepName: string;
  Remark: string;
  ForwardingComment: string;
  NextWFUser: string;
  NextWFUserName: string;
}

export interface IIAX_WF_Archive_Document_Sub extends IPageObj {
  ID: string;
  WorkflowInstanceID: string;
  Type: Type_10;
  Extension: string;
  Description: string;
  ArchivePath: string;
  Added: Date;
  AddedBy: string;
  StorageProvider: string;
  ExternalIDCalculated: string;
}

export interface IIAX_WF_GL_Entry_Subpage extends IPageObj {
  Entry_No: number;
  G_L_Account_No: string;
  Posting_Date: Date;
  GLDocumentType: Document_Type_6;
  Document_No: string;
  Description: string;
  Bal_Account_No: string;
  Amount: number;
  Global_Dimension_1_Code: string;
  Global_Dimension_2_Code: string;
  User_ID: string;
  Source_Code: string;
  System_Created_Entry: boolean;
  Prior_Year_Entry: boolean;
  Job_No: string;
  Quantity: number;
  VAT_Amount: number;
  Business_Unit_Code: string;
  Journal_Batch_Name: string;
  Reason_Code: string;
  Gen_Posting_Type: Gen_Posting_Type_47;
  Gen_Bus_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  GL_Bal_Account_Type: Bal_Account_Type_51;
  Transaction_No: number;
  Debit_Amount: number;
  Credit_Amount: number;
  Document_Date: Date;
  External_Document_No: string;
  Source_Type: Source_Type;
  Source_No: string;
  No_Series: string;
  Tax_Area_Code: string;
  Tax_Liable: boolean;
  Tax_Group_Code: string;
  Use_Tax: boolean;
  VAT_Bus_Posting_Group: string;
  VAT_Prod_Posting_Group: string;
  Additional_Currency_Amount: number;
  Add_Currency_Debit_Amount: number;
  Add_Currency_Credit_Amount: number;
  Close_Income_Statement_Dim_ID: number;
  IC_Partner_Code: string;
  Reversed: boolean;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  G_L_Account_Name: string;
  Dimension_Set_ID: number;
  Prod_Order_No: string;
  FA_Entry_Type: FA_Entry_Type;
  FA_Entry_No: number;
  Prozess: string;
  Fälligkeitsdatum: Date;
  KTR_1_Gruppe: string;
  KTR_2_Gruppe: string;
  KTR_3_Gruppe: string;
  Ergebnisgliederungscode: string;
  Finanzgliederungscode: string;
  Vermögensgliederungscode: string;
  lfd_Nr_Veranlagung: number;
  KST_1_Gruppe: string;
  KST_2_Gruppe: string;
  KST_3_Gruppe: string;
  Finanzbuchungsgruppe: string;
  Kontotyp: Kontotyp;
  Budgetebenencode: string;
  Budget: string;
  Bewirtschaftungsstelle: string;
  Investitionsnr: string;
  Haushaltsstelle: string;
  FAD_Nr: string;
  V_Jahr: number;
  Haushaltsjahr: number;
  Objektnummer: string;
  Abgabenart_Objekt: string;
  Abgabenart_Verkaufsklasse: string;
  GKZ: string;
  Budgetno: string;
  Berechtigungscode: string;
  Mittelherkunft: Mittelherkunft_5010395;
  Rücklastschrift: boolean;
  MBV_Journal_Code: string;
  Journal_Template_Name: string;
  MwSt_auf_eigene_Finanzb_grp: boolean;
  Description_2: string;
  Vorabdotierungsnr: string;
  Vorgang_No: string;
  Vorgangsposten_Lfd_Nr: number;
}

export interface IIAX_WF_CL_Entry_Subpage extends IPageObj {
  Entry_No: number;
  Customer_No: string;
  Posting_Date: Date;
  Document_Type: Document_Type_6;
  Document_No: string;
  Description: string;
  Currency_Code: string;
  Amount: number;
  Remaining_Amount: number;
  Original_Amt_LCY: number;
  Remaining_Amt_LCY: number;
  Amount_LCY: number;
  Sales_LCY: number;
  Profit_LCY: number;
  Inv_Discount_LCY: number;
  Sell_to_Customer_No: string;
  Customer_Posting_Group: string;
  Global_Dimension_1_Code: string;
  Global_Dimension_2_Code: string;
  Salesperson_Code: string;
  User_ID: string;
  Source_Code: string;
  On_Hold: string;
  Applies_to_Doc_Type: Document_Type_6;
  Applies_to_Doc_No: string;
  Open: boolean;
  Due_Date: Date;
  Pmt_Discount_Date: Date;
  Original_Pmt_Disc_Possible: number;
  Pmt_Disc_Given_LCY: number;
  Positive: boolean;
  Closed_by_Entry_No: number;
  Closed_at_Date: Date;
  Closed_by_Amount: number;
  Applies_to_ID: string;
  Journal_Batch_Name: string;
  Reason_Code: string;
  Bal_Account_Type: Bal_Account_Type_51;
  Bal_Account_No: string;
  Transaction_No: number;
  Closed_by_Amount_LCY: number;
  Debit_Amount: number;
  Credit_Amount: number;
  Debit_Amount_LCY: number;
  Credit_Amount_LCY: number;
  Document_Date: Date;
  External_Document_No: string;
  Calculate_Interest: boolean;
  Closing_Interest_Calculated: boolean;
  No_Series: string;
  Closed_by_Currency_Code: string;
  Closed_by_Currency_Amount: number;
  Adjusted_Currency_Factor: number;
  Original_Currency_Factor: number;
  Original_Amount: number;
  Date_Filter: Date;
  Remaining_Pmt_Disc_Possible: number;
  Pmt_Disc_Tolerance_Date: Date;
  Max_Payment_Tolerance: number;
  Last_Issued_Reminder_Level: number;
  Accepted_Payment_Tolerance: number;
  Accepted_Pmt_Disc_Tolerance: boolean;
  Pmt_Tolerance_LCY: number;
  Amount_to_Apply: number;
  IC_Partner_Code: string;
  Applying_Entry: boolean;
  Reversed: boolean;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  Prepayment: boolean;
  Debitorenname: string;
  Mahnungsnr: string;
  Mahnmethodencode: string;
  Mahndatum: Date;
  VA_Zeilennr: number;
  Erfassungsart: Erfassungsart;
  Objekt_Name: string;
  Veranlagungsart: Veranlagungsart;
  Abgabenart_Name: string;
  Rechnungsart: Rechnungsart_5010309;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  BLZ: string;
  Bankkontonr: string;
  Zahlungsformcode: string;
  Bank_geändert_von: string;
  Bank_geändert_am: Date;
  Kontoinhaber: string;
  Mahnart: Mahnart_5010323;
  Zinsen: number;
  Forderungsart: Forderungsart;
  Mahnstufe: number;
  Abrechnung: boolean;
  Vorauszahlung: boolean;
  Zahlbetrag: number;
  Verrechnungsbetrag: number;
  Lfd_Nr_Hauptforderung: number;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Strasse_Adresse: string;
  PLZ_Adresse: string;
  Ort_Adresse: string;
  Ländercode_Adresse: string;
  Suchbegriff_Adresse: string;
  Bemerkungen_Adresse: boolean;
  Mahnsperre_Adresse: boolean;
  Ländercode_Text_Adresse: string;
  MBV_Journal_Nr: number;
  Datum_der_Verbuchung: Date;
  intern: boolean;
  MBV_Journal_Code: string;
  Sachkonto_Buch_Gruppe: string;
  Bemerkungen_Debitor: boolean;
  IBAN: string;
  SWIFT_Code: string;
  Finanzbuchungsgruppe: string;
  Investitionsnr: string;
  Haushaltsstelle: string;
  Adressnr: string;
  VA_Jahr: number;
  Objektnr: string;
  Abgabenart_Objekt: string;
  Abgabenart_Verkaufsklasse: string;
  Gemeindenr: string;
  storniert: boolean;
  storniert_am: Date;
  storniert_von: string;
  Kontobezeichnung: string;
  Aggregationsnr: number;
  Aggr_Restbetrag: number;
  Aggr_Betrag: number;
  Forderungsartfilter: Forderungsart;
  Zeitstempel: Date;
  Berechtigungscode: string;
  Rücklastschrift: boolean;
  Erweiterter_Belegtext: string;
  Internal_Document_Type: Internal_Document_Type;
  Internal_Document_No: string;
  Ext_Belgnr_Filter: string;
  Ext_Belgnr_Existiert: boolean;
  Abwarten_Name: string;
  Vorgangsnr: string;
  Journal_Template_Name: string;
  Aufrechnungsbuchungsgruppe: string;
  Erweiterte_Belegnummern: boolean;
  HF_zur_NF_geschlossen: boolean;
  Ausgeglichener_Betrag: number;
  Sperre_Adresse: boolean;
  Personennr: string;
  Gemeindenr_Objekt: string;
  Anzahl_Empfänger_zur_Adresse: number;
  Anzahl_Eigentümer_zur_Adresse: number;
  Mandatsreferenz_Lfd_Nr: number;
}

export interface IIAX_WF_VL_Entry_Subpage extends IPageObj {
  Entry_No: number;
  Vendor_No: string;
  Posting_Date: Date;
  Document_Type: Document_Type_6;
  Document_No: string;
  Description: string;
  Currency_Code: string;
  Amount: number;
  Remaining_Amount: number;
  Original_Amt_LCY: number;
  Remaining_Amt_LCY: number;
  Amount_LCY: number;
  Purchase_LCY: number;
  Inv_Discount_LCY: number;
  Buy_from_Vendor_No: string;
  Vendor_Posting_Group: string;
  Global_Dimension_1_Code: string;
  Global_Dimension_2_Code: string;
  Purchaser_Code: string;
  User_ID: string;
  Source_Code: string;
  On_Hold: string;
  Applies_to_Doc_Type: Document_Type_6;
  Applies_to_Doc_No: string;
  Open: boolean;
  Due_Date: Date;
  Pmt_Discount_Date: Date;
  Original_Pmt_Disc_Possible: number;
  Pmt_Disc_Rcd_LCY: number;
  Positive: boolean;
  Closed_by_Entry_No: number;
  Closed_at_Date: Date;
  Closed_by_Amount: number;
  Applies_to_ID: string;
  Journal_Batch_Name: string;
  Reason_Code: string;
  Bal_Account_Type: Bal_Account_Type_51;
  Bal_Account_No: string;
  Transaction_No: number;
  Closed_by_Amount_LCY: number;
  Debit_Amount: number;
  Credit_Amount: number;
  Debit_Amount_LCY: number;
  Credit_Amount_LCY: number;
  Document_Date: Date;
  External_Document_No: string;
  No_Series: string;
  Closed_by_Currency_Code: string;
  Closed_by_Currency_Amount: number;
  Adjusted_Currency_Factor: number;
  Original_Currency_Factor: number;
  Original_Amount: number;
  Date_Filter: Date;
  Remaining_Pmt_Disc_Possible: number;
  Pmt_Disc_Tolerance_Date: Date;
  Max_Payment_Tolerance: number;
  Accepted_Payment_Tolerance: number;
  Accepted_Pmt_Disc_Tolerance: boolean;
  Pmt_Tolerance_LCY: number;
  Amount_to_Apply: number;
  IC_Partner_Code: string;
  Applying_Entry: boolean;
  Reversed: boolean;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  Prepayment: boolean;
  Mahnmethodencode: string;
  Eingangsdatum: Date;
  lfd_Nr_Veranlagung: number;
  Rechnungsart: Rechnungsart_5010309;
  Bankzahlungsart: Bankzahlungsart_5010310;
  BankkontoCode: string;
  Bankleitzahlcode: string;
  Bankkontonummer: string;
  Zahlungsformcode: string;
  Bank_Geändert_Von: string;
  Bank_Geändert_Am: Date;
  Kontoinhaber: string;
  MBV_Journal_Nr: number;
  Datum_der_Verbuchung: Date;
  Mahnart: Mahnart_5010323;
  Zahlbetrag: number;
  Verrechnungsbetrag: number;
  Strasse_Adresse: string;
  PLZ_Adresse: string;
  Ort_Adresse: string;
  Ländercode_Adresse: string;
  Suchbegriff_Adresse: string;
  Ländercode_Text_Adresse: string;
  MBV_Journal_Code: string;
  Sachkonto_Buch_Gruppe: string;
  IBAN: string;
  SWIFT_Code: string;
  Finanzbuchungsgruppe: string;
  Investitionsnr: string;
  Haushaltsstelle: string;
  Adressnr: string;
  Veranlagungsjahr: number;
  Objektnummer: string;
  Abgabenart_Objekt: string;
  Abgabenart_Verkaufsklasse: string;
  Gemeindenr: string;
  Kreditorenname: string;
  Abgabenart_Name: string;
  Kontobezeichnung: string;
  Bemerkungen_Adresse: boolean;
  Bemerkungen_Kreditor: boolean;
  Zeitstempel: Date;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Berechtigungscode: string;
  Rücklastschrift: boolean;
  Erweiterter_Belegtext: string;
  Abwarten_Name: string;
  Journal_Template_Name: string;
  Ausgeglichener_Betrag: number;
  Erweiterte_Belegnummern: boolean;
  Vorgangsnr: string;
  Personennr: string;
  MwStDatum: Date;
}

export interface IIAX_WF_FA_Entry_Subpage extends IPageObj {
  Entry_No: number;
  G_L_Entry_No: number;
  FA_No: string;
  FA_Description: string;
  Depreciation_Book_Code: string;
  FA_Posting_Group: string;
  FA_Subclass_Code: string;
  FA_Class_Code: string;
  FA_Location_Code: string;
  Global_Dimension_1_Code: string;
  Global_Dimension_2_Code: string;
  Berecht_code_Bew_stelle: string;
  Investitionsnr: string;
  Gemeindenr: string;
  Document_Type: Document_Type_6;
  Document_No: string;
  External_Document_No: string;
  Description: string;
  Description_2: string;
  FA_Posting_Date: Date;
  Posting_Date: Date;
  Document_Date: Date;
  FA_Posting_Type: FA_Posting_Type;
  FA_Posting_Category: FA_Posting_Category;
  Result_on_Disposal: Result_on_Disposal;
  Amount: number;
  Debit_Amount: number;
  Credit_Amount: number;
  Quantity: number;
  Price: number;
  Reclassification_Entry: boolean;
  Part_of_Book_Value: boolean;
  Part_of_Depreciable_Basis: boolean;
  User_ID: string;
  Depreciation_Method: Depreciation_Method;
  Depreciation_Starting_Date: Date;
  Straight_Line_Percent: number;
  No_of_Depreciation_Years: number;
  Fixed_Depr_Amount: number;
  Declining_Balance_Percent: number;
  Depreciation_Table_Code: string;
  Source_Code: string;
  Journal_Batch_Name: string;
  Journal_Template_Name: string;
  MBV_Journal_Code: string;
  Transaction_No: number;
  VAT_Amount: number;
  Gen_Posting_Type: Gen_Posting_Type_47;
  Gen_Bus_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  VAT_Bus_Posting_Group: string;
  VAT_Prod_Posting_Group: string;
  Index_Entry: boolean;
  Correction: boolean;
  Reversed: boolean;
  Canceled_from_FA_No: string;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  Buchungsstelle: string;
  Gliederung: string;
  Gruppierung: string;
  Partial_Disposal: boolean;
  Partial_Disposal_FA_No: string;
  Is_PartialDisposal_for_FANo: string;
}

export interface IIAX_Purchase_Order_Subform_Reg extends IPageObj {
  Document_No: string;
  Bestellzeilennr: number;
  Status: Status_;
  Type: Type_5;
  No: string;
  fn_GetKontobezeichnung: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  Cross_Reference_No: string;
  IC_Partner_Ref_Type: IC_Partner_Ref_Type;
  IC_Partner_Reference: string;
  Variant_Code: string;
  Nonstock: boolean;
  VAT_Prod_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  Sachkonto_Buch_Gruppe: string;
  Description: string;
  Description_2: string;
  Haushaltsstelle: string;
  Return_Reason_Code: string;
  Location_Code: string;
  Bin_Code: string;
  Drop_Shipment: boolean;
  Order_Date: Date;
  Requested_Receipt_Date: Date;
  Promised_Receipt_Date: Date;
  Planned_Receipt_Date: Date;
  Expected_Receipt_Date: Date;
  Quantity: number;
  Reserved_Quantity: number;
  Unit_of_Measure_Code: string;
  Unit_of_Measure: string;
  Unit_Cost_LCY: number;
  Direct_Unit_Cost: number;
  Line_Amount: number;
  Line_Discount_Percent: number;
  Line_Discount_Amount: number;
  Betrag_akt_Rechnung: number;
  Mittelherkunft: Mittelherkunft_5010395;
  Allow_Invoice_Disc: boolean;
  Inv_Discount_Amount: number;
  Allow_Item_Charge_Assignment: boolean;
  Qty_to_Assign: number;
  Qty_Assigned: number;
  Indirect_Cost_Percent: number;
  Unit_Price_LCY: number;
  Job_No: string;
  Blanket_Order_No: string;
  Blanket_Order_Line_No: number;
  FA_Posting_Date: Date;
  Depr_until_FA_Posting_Date: boolean;
  Verzinsung_bis_Anlagedatum: boolean;
  Depreciation_Book_Code: string;
  FA_Posting_Type: FA_Posting_Type_5601;
  Use_Duplication_List: boolean;
  Duplicate_in_Depreciation_Book: string;
  Depr_Acquisition_Cost: boolean;
  Budgeted_FA_No: string;
  Insurance_No: string;
  Appl_to_Item_Entry: number;
  Gemeindenr: string;
  Gen_Bus_Posting_Group: string;
  Verteilung: number;
  ShortcutDimCode3: string;
  ShortcutDimCode4: string;
  ShortcutDimCode5: string;
  ShortcutDimCode6: string;
  ShortcutDimCode7: string;
  ShortcutDimCode8: string;
  Investitionsnr: string;
  Investitionsname: string;
  Vorabdotierungsnr: string;
  Vorgangsnummer: string;
  Verpf_Ermächtigungsnr: string;
  Jahr_für_VE: number;
  Product_Group_Code: string;
  Auftragsnummer: string;
  Lead_Time_Calculation: string;
  Whse_Outstanding_Qty_Base: number;
  Inbound_Whse_Handling_Time: string;
  Abgeschlossen_Jahr: number;
}

export interface IIAX_WF_Add_Information_Sub extends IPageObj {
  WFInstanceNo: string;
  Key1: string;
  DocumentNo: string;
  Description: string;
  TextValue: string;
  RecordIDValue: string;
}

export interface IIAX_WF_PK_Entry_Subpage extends IPageObj {
  Lfd_Nr: number;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Strasse_Adresse: string;
  PLZ_Adresse: string;
  Ort_Adresse: string;
  Sollbetrag: number;
  Istbetrag: number;
  Gemeindenr: string;
  HHJahr: number;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Adressnr: string;
  Abgabenart: string;
  Objektnr: string;
  Kassenzeichen: string;
  BWSt: string;
  Belegnr: number;
  HÜL_Nr: number;
  Unterkonto: string;
  Vorgangsnr: number;
  Haushaltsstellenr: string;
  Forderungsart: Forderungsart_19;
  Fälligkeitsdatum: Date;
  Buchungstext: string;
  Storno: boolean;
  Einnahme_Ausgabe: Einnahme_Ausgabe_47;
  Überweisungstext: string;
  Überweisungstext_2: string;
  Überweisungstext_3: string;
  Überweisungstext_4: string;
  Überweisungstext_5: string;
  Clearing: boolean;
  Zahlungsnr: number;
}

export interface IIAX_WF_HHST_Entry_Subpage extends IPageObj {
  Lfd_Nr: number;
  Gemeindenr: string;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Adressnr: string;
  HÜL_Nr: number;
  Kassenzeichen: string;
  Belegnr: number;
  Abgabenart: string;
  Unterkonto: string;
  Vorgangsnr: number;
  Haushaltsstellenr: string;
  Fälligkeitsdatum: Date;
  USt_Betrag: number;
  Buchungstext: string;
  BWSt: string;
  Zahlweg: string;
  Zahldatum: Date;
  Storno: boolean;
  Abwicklungsnr_zus_Zahlung: number;
  Einnahme_Ausgabe: Einnahme_Ausgabe_47;
  Betrag: number;
  Clearing: boolean;
  Name_Adresse: string;
  Name_2_Adresse: string;
  Name_3_Adresse: string;
  Strasse_Adresse: string;
  PLZ_Adresse: string;
  Ort_Adresse: string;
}

export interface IIAX_Wizrd_Creation_Lines extends IPageObj {
  GUID: string;
  Line_No: number;
  Description: string;
  Description_2: string;
  Amount: number;
  Quantity: number;
  UnitPrice: number;
}

export interface IIAX_Cust_Bank_Account_Sub extends IPageObj {
  Code: string;
  Name: string;
  Name_2: string;
  Address: string;
  Address_2: string;
  City: string;
  Post_Code: string;
  Bank_Branch_No: string;
  Bank_Account_No: string;
  IBAN: string;
  SWIFT_Code: string;
  Customer_No: string;
  Contact: string;
  Phone_No: string;
  Telex_No: string;
  Transit_No: string;
  Currency_Code: string;
  Country_Region_Code: string;
  County: string;
  Fax_No: string;
  Telex_Answer_Back: string;
  Language_Code: string;
  E_Mail: string;
  Home_Page: string;
  Clearing: boolean;
  Alternative_Account_Owner: string;
  Date_of_Signature: Date;
  Mandate_Identification: string;
  Amendment_Indicator: boolean;
  Amendment_Info_Details: string;
  Last_Payment_Date: Date;
  Reason_of_Amendment: string;
  Date_of_Amendment: Date;
  Lfd_Nr_Bankverbindung_HKR: number;
  Inhaber_Name: string;
  Inhaber_Name_2: string;
  Inhaber_Name_3: string;
  Inhaber_Suchbegriff: string;
  Inhaber_Strasse_und_Hausnr: string;
  Inhaber_Länderkennzeichen: string;
  Inhaber_Anschrift_PLZ: string;
  Inhaber_Anschrift_Ort: string;
  Inhaber_Telefonnr: string;
  Inhaber_Mobile_Telefonnr: string;
  Inhaber_Faxnr: string;
  Inhaber_E_Mail: string;
  Objektnr: string;
  Abgabenart_Verkaufsklasse: string;
  Gemeindenr: string;
  Abbuchung: boolean;
  Auszahlung: boolean;
  Inhaber_Hausnr: number;
  Inhaber_Hausnrzusatz: string;
  Inhaber_Strassenbezeichnung: string;
  Inhaber_Strassennr: string;
  Inhaber_Strassenname: string;
  Inhaber_Strasse_und_Hausnr_2: string;
  Inhaber_Ortsteilnr: string;
  Inhaber_Ortsteilname: string;
  Anredecode: string;
  Anschrift_von_Debitor: string;
  Ländercode_Text: string;
  Inhaber_Strassenbezeichnung2: string;
  gültig_ab: Date;
  gültig_bis: Date;
  Entstanden_aus_Extern_ID: string;
  Lfd_Nr_PK_Bankverbindung_HKR: number;
  Bezeichnung: string;
  Mandatsreferenz_Lfd_Nr: number;
}

export interface IIAX_Vendor_Bank_Account_Sub extends IPageObj {
  Vendor_No: string;
  Code: string;
  Name: string;
  Name_2: string;
  Address: string;
  Address_2: string;
  City: string;
  Post_Code: string;
  Contact: string;
  Phone_No: string;
  Telex_No: string;
  Bank_Branch_No: string;
  Bank_Account_No: string;
  Transit_No: string;
  Currency_Code: string;
  Country_Region_Code: string;
  County: string;
  Fax_No: string;
  Telex_Answer_Back: string;
  Language_Code: string;
  E_Mail: string;
  Home_Page: string;
  IBAN: string;
  SWIFT_Code: string;
  Clearing: boolean;
  Alternative_Account_Owner: string;
  Lfd_Nr_Bankverbindung_HKR: number;
  Inhaber_Name: string;
  Inhaber_Name_2: string;
  Inhaber_Name_3: string;
  Inhaber_Suchbegriff: string;
  Inhaber_Strasse_und_Hausnr: string;
  Inhaber_Länderkennzeichen: string;
  Inhaber_Anschrift_PLZ: string;
  Inhaber_Anschrift_Ort: string;
  Inhaber_Telefonnr: string;
  Inhaber_Mobile_Telefonnr: string;
  Inhaber_Faxnr: string;
  Inhaber_E_Mail: string;
  Objektnr: string;
  Abgabenart_Verkaufsklasse: string;
  Gemeindenr: string;
  Abbuchung: boolean;
  Auszahlung: boolean;
  Inhaber_Hausnr: number;
  Inhaber_Hausnrzusatz: string;
  Inhaber_Strassenbezeichnung: string;
  Inhaber_Strassennr: string;
  Inhaber_Strassenname: string;
  Inhaber_Strasse_und_Hausnr_2: string;
  Inhaber_Ortsteilnr: string;
  Inhaber_Ortsteilname: string;
  Anredecode: string;
  Anschrift_von_Kreditor: string;
  Ländercode_Text: string;
  Inhaber_Strassenbezeichnung2: string;
  gültig_ab: Date;
  gültig_bis: Date;
  Entstanden_aus_Extern_ID: string;
  Lfd_Nr_PK_Bankverbindung_HKR: number;
  Bezeichnung: string;
}

export interface IIAX_DMS_Sales_Document_Line extends IPageObj {
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Document_No: string;
  Line_No: number;
  Type: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  No: string;
  Kontobez: string;
  Parent_DMS_Doc_No: string;
  PDate: Date;
  DDate: Date;
  CommNo: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  IC_Partner_Code: string;
  IC_Partner_Ref_Type: IC_Partner_Ref_Type;
  IC_Partner_Reference: string;
  Variant_Code: string;
  Nonstock: boolean;
  VAT_Prod_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  Sachkonto_Buch_Gruppe: string;
  Description: string;
  Description_2: string;
  Haushaltsstelle: string;
  Return_Reason_Code: string;
  Location_Code: string;
  Bin_Code: string;
  AdditionalRecordKB_Work_Order_No: string;
  AdditionalRecordKB_Activity_Type: string;
  AdditionalRecordKB_Communal_Object_No: string;
  AdditionalRecordKB_Communal_Object_Unit: string;
  Quantity: number;
  Unit_of_Measure_Code: string;
  Unit_of_Measure: string;
  Unit_Cost_LCY: number;
  PriceExists: boolean;
  Unit_Price: number;
  Line_Amount: number;
  Line_Discount_Percent: number;
  Line_Discount_Amount: number;
  Mittelherkunft: Mittelherkunft_5010395;
  Allow_Invoice_Disc: boolean;
  Inv_Discount_Amount: number;
  Allow_Item_Charge_Assignment: boolean;
  Qty_to_Assign: number;
  Qty_Assigned: number;
  Job_No: string;
  Job_Task_No: string;
  Job_Contract_Entry_No: number;
  Work_Type_Code: string;
  Blanket_Order_No: string;
  Blanket_Order_Line_No: number;
  FA_Posting_Date: Date;
  Depr_until_FA_Posting_Date: boolean;
  Verzinsung_bis_Anlagedatum: boolean;
  Depreciation_Book_Code: string;
  FA_Posting_Type: /**_blank_*/0 |/**Zuschusseingang*/1 |/**Disposal*/2 |/**Partial_Disposal*/3;
  Use_Duplication_List: boolean;
  Duplicate_in_Depreciation_Book: string;
  Appl_from_Item_Entry: number;
  Appl_to_Item_Entry: number;
  Shipment_Date: Date;
  Mahnart: /**_blank_*/0 |/**privat_rechtlich*/1 |/**öffentlich_rechtlich*/2;
  Mahnmethodencode: string;
  Gemeindenr: string;
  Gemeinde: string;
  Gen_Bus_Posting_Group: string;
  Verteilung: number;
  Aufwands_KST: string;
  Aufwands_KTR: string;
  Aufwands_Konto: string;
  ShortcutDimCode3: string;
  ShortcutDimCode4: string;
  ShortcutDimCode5: string;
  ShortcutDimCode6: string;
  ShortcutDimCode7: string;
  ShortcutDimCode8: string;
  Investitionsnr: string;
  Investitionsname: string;
  Vorabdotierungsnr: string;
  Vorgangsnummer: string;
  HasAddRecLuGM: boolean;
  AddRecLuGMEntryNo: number;
  FA_Quantity: number;
  Deferral_Code: string;
  Vertragsnr: string;
  Vertragszeilenr: number;
  VAT_Amount: number;
}

export interface IIAX_LuGM_Zusatzdaten_Line extends IPageObj {
  Table_ID: number;
  Int1: number;
  Int2: number;
  Code1: string;
  Code2: string;
  Entry_No: number;
  Vertragsnr: string;
  Vertragszeilennr: number;
  Vertragsklasse: /**_blank_*/0 |/**General*/1 |/**EVU*/2 |/**Pacht*/3 |/**Reinigung*/4 |/**Grundstück*/5;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4 |/**_blank_*/5;
  Liegenschaftsnr: string;
  Gebäudenr: string;
  Gebäudeteilnr: string;
  Geschosscode: string;
  Raumcode: string;
  Ausrüstungsnr: string;
  Objektcode: string;
  Objekttyp_Mietverwaltung: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mieteinheit*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverwaltung: string;
  Mietvertragsnr: string;
  Mietvertragszeilennr: number;
  Nebenkostenschlüssel: string;
  Nebenkosten_von: Date;
  Nebenkosten_bis: Date;
  Nebenkostenabrechungsnr: number;
  Maßnahmenr: string;
  Gewerkenr: string;
  Abschlagsart: string;
  Meldungsnummer: string;
  Meldungsvorgangsnummer: string;
  Erbbaurechtsvertragsnr: string;
  Erbbaurechtsvertragszeilennr: number;
  Entry_No_G_L_Entry: number;
  Entry_No_Cust_Legder_Entry: number;
  Entry_No_Vendor_Ledger_Entry: number;
  Zusatz_Table_ID: number;
  Zusatz_Int1: number;
  Zusatz_Int2: number;
  Zusatz_Code1: string;
  Zusatz_Code2: string;
  Amount: number;
  ReverseFromFM: boolean;
  Transaction_No: number;
  Objektbezeichnung: string;
  Maßnahmenr_ILV: string;
  Gewerkenr_ILV: string;
  Vertragsklasse_ILV: /**_blank_*/0 |/**General*/1 |/**EVU*/2 |/**Pacht*/3 |/**Reinigung*/4 |/**Grundstück*/5;
  Vertragsnr_ILV: string;
  Objekttyp_Mietverw_ILV: /**_blank_*/0 |/**Mietvertrag*/1 |/**Mieteinheit*/2 |/**Gemeinschaftsfläche*/3 |/**Vorverteilungseinheit*/4 |/**Basisobjekt*/5 |/**Abrechnungseinheit*/6;
  Objekt_Mietverw_ILV: string;
  Nebenkostenschlüssel_ILV: string;
  Nebenkosten_von_ILV: Date;
  Nebenkosten_bis_ILV: Date;
  Geschäftsvorfallcode_ILV: string;
  Maßnahmenbuchung_ILV: boolean;
  Vertragsbuchung_ILV: boolean;
  Mietvertragsbuchung_ILV: boolean;
  Reg_No: number;
  Document_Date: Date;
  Ext_Document_No: string;
  Reversed: boolean;
  Reversed_by_Entry_No: number;
  Reversed_Entry_No: number;
  Int3: number;
  Zusatz_Int3: number;
  Geschäftsvorfallcode: string;
  Maßnahmenbuchung: boolean;
  Meldungsbuchung: boolean;
  Vertragsbuchung: boolean;
  Erbbaurechtsbuchung: boolean;
  Mietvertragsbuchung: boolean;
  Belegart: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Erstellt_am_Verkauf: Date;
  Erstellt_von_Verkauf: string;
  Art_Verkauf: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  Kontonr_Verkauf: string;
  Beschreibung_Verkauf: string;
  Beschreibung_2_Verkauf: string;
  Kostenstelle_Verkauf: string;
  Kostenträger_Verkauf: string;
  Fälligkeitsdatum_Verkauf: Date;
  Buchungsdatum_Verkauf: Date;
  Debitorennr_Verkauf: string;
  Debitorenname_Verkauf: string;
  Erstellt_am_Einkauf: Date;
  Erstellt_von_Einkauf: string;
  Art_Einkauf: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  Kontonr_Einkauf: string;
  Beschreibung_Einkauf: string;
  Beschreibung_2_Einkauf: string;
  Kostenstelle_Einkauf: string;
  Kostenträger_Einkauf: string;
  Fälligkeitsdatum_Einkauf: Date;
  Buchungsdatum_Einkauf: Date;
  Kreditorennr_Einkauf: string;
  Kreditorenname_Einkauf: string;
  Zahlungsart_Einkauf: Zahlungsart;
  Betrag_akt_Rechnung: number;
  Restbetrag: number;
  Bestelldatum_Einkauf: Date;
  Kred_Rechnungsnr_Einkauf: string;
  Kostenstelle_Name_Verkauf: string;
  Kostenträger_Name_Verkauf: string;
  Kostenstelle_Name_Einkauf: string;
  Kostenträger_Name_Einkauf: string;
  Status_Einkauf: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  Status_Verkauf: /**Open*/0 |/**Released*/1 |/**Pending_Approval*/2 |/**Pending_Prepayment*/3;
  bereits_berechneter_Betrag: number;
  Posting_Descritopn_Sales: string;
  Posting_Descritopn_Purchase: string;
  Allocated_Amount_Purchase: number;
  Line_Amount_Sales: number;
  Line_Amount_Purchase: number;
  Verarbeitungsstatus_Einkauf: /**erfasst*/0 |/**freigegeben*/1 |/**zurückgestellt*/2 |/**gebucht*/3 |/**teilgebucht*/4 |/**auf_Freigabeliste*/5;
  Verarbeitungsstatus_Verkauf: /**Erfasst*/0 |/**Freigegeben*/1 |/**Zurückgestellt*/2 |/**Gebucht*/3 |/**Teilgebucht*/4 |/**Auf_Freigabeliste*/5;
  EVU_AbrechnungsNr: string;
  Debitorennr: string;
  Kreditorennr: string;
  MesspunktNr: string;
  Reinigungsrevier: string;
  Bruttobetrag: number;
  Restbetrag_offen: number;
  Sachkontonr: string;
  Kostenstelle: string;
  Kostenträger: string;
  Zahlbetrag: number;
  Posting_Date: Date;
  DescriptionGLEntry: string;
  Vergabesumme: number;
  Vertragstyp: /**_blank_*/0 |/**Hauptauftrag*/1 |/**Nachtrag*/2 |/**Abruf_Rahmenvertrag*/3 |/**Minderung*/4 |/**Vorsorge*/5;
  davon_zuwendungsfähig: number;
  erwartete_Zuwendung: number;
  erwartete_Weiterbelastung: number;
  Interne_Nr: string;
  Massnahmenbeschreibung: string;
  Gewerkebezeichnung: string;
  Meldungsbezeichnung: string;
  Ausrüstungsbezeichnung: string;
  Vertragsbezeichnung: string;
  Messpunktbeschreibung: string;
  Reinigungsrevierbeschreibung: string;
  Mietvertragsbeschreibung: string;
  Nebenkostenschlüsselbezeichnung: string;
  WFGuid: string;
}

export interface IIAX_DMSPurch_DocumentLine extends IPageObj {
  Document_Type: /**Quote*/0 |/**Order*/1 |/**Invoice*/2 |/**Credit_Memo*/3 |/**Blanket_Order*/4 |/**Return_Order*/5;
  Document_No: string;
  Line_No: number;
  Type: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  No: string;
  Kontobez: string;
  Parent_DMS_Doc_No: string;
  PDate: Date;
  DDate: Date;
  LDate: Date;
  CommNo: string;
  Shortcut_Dimension_1_Code: string;
  Kostenstelle_Name: string;
  Shortcut_Dimension_2_Code: string;
  Kostenträger_Name: string;
  IC_Partner_Code: string;
  IC_Partner_Ref_Type: IC_Partner_Ref_Type;
  IC_Partner_Reference: string;
  Variant_Code: string;
  Nonstock: boolean;
  VAT_Prod_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  Sachkonto_Buch_Gruppe: string;
  Description: string;
  Description_2: string;
  Return_Reason_Code: string;
  Location_Code: string;
  Bin_Code: string;
  Quantity: number;
  Unit_of_Measure_Code: string;
  Unit_of_Measure: string;
  Unit_Cost_LCY: number;
  Direct_Unit_Cost: number;
  Line_Amount: number;
  Line_Discount_Percent: number;
  Line_Discount_Amount: number;
  Mittelherkunft: Mittelherkunft_5010395;
  Gemeindenr: string;
  Gemeinde: string;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederung_Ergänzung: string;
  Gruppierung: string;
  Gruppierung_Ergänzung: string;
  Unterkonto: string;
  Allow_Invoice_Disc: boolean;
  Inv_Discount_Amount: number;
  Allow_Item_Charge_Assignment: boolean;
  Qty_to_Invoice: number;
  Qty_to_Assign: number;
  Qty_Assigned: number;
  Indirect_Cost_Percent: number;
  Unit_Price_LCY: number;
  Job_No: string;
  Job_Task_No: string;
  Job_Line_Type: /**_blank_*/0 |/**Budget*/1 |/**Billable*/2 |/**Both_Budget_and_Billable*/3;
  Job_Unit_Price: number;
  Job_Line_Amount: number;
  Job_Line_Discount_Amount: number;
  Job_Line_Discount_Percent: number;
  Job_Total_Price: number;
  Job_Unit_Price_LCY: number;
  Job_Total_Price_LCY: number;
  Job_Line_Amount_LCY: number;
  Job_Line_Disc_Amount_LCY: number;
  Blanket_Order_No: string;
  Blanket_Order_Line_No: number;
  FA_Posting_Date: Date;
  Depr_until_FA_Posting_Date: boolean;
  Verzinsung_bis_Anlagedatum: boolean;
  Depreciation_Book_Code: string;
  FA_Posting_Type: /**_blank_*/0 |/**Acquisition_Cost*/1 |/**Maintenance*/2 |/**Appreciation*/3;
  Use_Duplication_List: boolean;
  Duplicate_in_Depreciation_Book: string;
  Depr_Acquisition_Cost: boolean;
  Budgeted_FA_No: string;
  Insurance_No: string;
  Appl_to_Item_Entry: number;
  Gen_Bus_Posting_Group: string;
  Verteilung: number;
  ShortcutDimCode3: string;
  ShortcutDimCode4: string;
  ShortcutDimCode5: string;
  ShortcutDimCode6: string;
  ShortcutDimCode7: string;
  ShortcutDimCode8: string;
  Investitionsnr: string;
  Investitionsname: string;
  Vorabdotierungsnr: string;
  Vorgangsnummer: string;
  Auftragsnummer: string;
  WorkOrderNo: string;
  IncidentNo: string;
  ActivityType: string;
  ComObj: string;
  ComObjUnit: string;
  Entry_No_KB_Additional_Record: number;
  HasAddRecLuGM: boolean;
  AddRecLuGMEntryNo: number;
  Order_Date: Date;
  Betrag_akt_Rechnung: number;
  Qty_to_Receive: number;
  Order_Line_No: number;
  FA_Quantity: number;
  Deferral_Code: string;
  Vertragsnr: string;
  Vertragszeilenr: number;
  VAT_Amount: number;
  Bereits_berechneter_Betrag: number;
  Restbetrag_zur_Fakturierung: number;
  Outstanding_Quantity: number;
  Quantity_Received: number;
  Quantity_Invoiced: number;
}

export interface IIAX_Auftragspositionen_Line extends IPageObj {
  Auftragsnr: string;
  Zeilennr: number;
  Gemeindenr: string;
  Haushaltsjahr: number;
  Haushalt: string;
  Gliederung: string;
  Gliederungsergänzung: string;
  Gruppierung: string;
  Gruppierungsergänzung: string;
  Unterkonto: string;
  Vorgangsnummer: number;
  Erfassungsart: /**Lfd_Haushaltsjahr*/0 |/**Haushaltsrest*/1 |/**Planwert*/2;
  Planung_auf_VE: boolean;
  Planjahr: number;
  Fälligkeitsdatum: Date;
  Betrag: number;
  MwSt_Code: string;
  MwSt_Percent: number;
  USt_Betrag: number;
  Quotierung_Vorsteuerabzug: number;
  Vorsteuer_Betrag: number;
  Betrag_steuerbereinigt: number;
  Buchungstext: string;
  Buchungstext_2: string;
  Maßnahmenr: string;
  Gewerkenr: string;
  Objekttyp: /**Liegenschaft*/0 |/**Gebäude*/1 |/**Gebäudeteil*/2 |/**Geschoss*/3 |/**Raum*/4;
  Objektcode: string;
  Vertragsdokument: boolean;
  Vertragsnr: string;
  LuGM_Art: /**Objekt*/0 |/**Ausrüstung*/1;
  Ausrüstungsnr: string;
  DokID: string;
}

export interface IIAX_Dokumente_Adresse extends IPageObj {
  Description: string;
  Modified: Date;
  Modified_by: string;
}

export interface IDeferral_Schedule_Line extends IPageObj {
  Posting_Date: Date;
  Description: string;
  Amount: number;
  TotalDeferral: number;
}

export interface IPurchase_Order_Line extends IPageObj {
  Type: /**_blank_*/0 |/**G_L_Account*/1 |/**Item*/2 |/**Resource*/3 |/**Fixed_Asset*/4 |/**Charge_Item*/5;
  FilteredTypeField: string;
  No: string;
  registriert: boolean;
  GetKontobezeichnung: string;
  Shortcut_Dimension_1_Code: string;
  Shortcut_Dimension_2_Code: string;
  Kostenstelle_Name: string;
  Kostenträger_Name: string;
  Budget_Res_Line: boolean;
  Cross_Reference_No: string;
  Item_Reference_No: string;
  IC_Partner_Code: string;
  IC_Partner_Ref_Type: IC_Partner_Ref_Type;
  IC_Partner_Reference: string;
  Variant_Code: string;
  Nonstock: boolean;
  VAT_Prod_Posting_Group: string;
  Gen_Prod_Posting_Group: string;
  Sachkonto_Buch_Gruppe: string;
  Description: string;
  Description_2: string;
  Haushaltsstelle: string;
  Return_Reason_Code: string;
  Location_Code: string;
  Bin_Code: string;
  Drop_Shipment: boolean;
  Order_Date: Date;
  Quantity: number;
  Unit_of_Measure_Code: string;
  Unit_of_Measure: string;
  Unit_Cost_LCY: number;
  Direct_Unit_Cost: number;
  Unit_Price_LCY: number;
  Tax_Liable: boolean;
  Tax_Area_Code: string;
  Tax_Group_Code: string;
  Use_Tax: boolean;
  Line_Amount: number;
  Line_Discount_Percent: number;
  Line_Discount_Amount: number;
  Prepayment_Percent: number;
  Prepmt_Line_Amount: number;
  Prepmt_Amt_Inv: number;
  Allow_Invoice_Disc: boolean;
  Inv_Discount_Amount: number;
  Betrag_akt_Rechnung: number;
  Bereits_berechneter_Betrag: number;
  Qty_to_Invoice: number;
  Quantity_Invoiced: number;
  Qty_to_Receive: number;
  Quantity_Received: number;
  Prepmt_Amt_to_Deduct: number;
  Prepmt_Amt_Deducted: number;
  Entry_No_KB_Additional_Record: number;
  Allow_Item_Charge_Assignment: boolean;
  Qty_to_Assign: number;
  Qty_Assigned: number;
  Indirect_Cost_Percent: number;
  Inv_Disc_Amount_to_Invoice: number;
  Job_No: string;
  Job_Task_No: string;
  Job_Planning_Line_No: number;
  Job_Line_Type: /**_blank_*/0 |/**Budget*/1 |/**Billable*/2 |/**Both_Budget_and_Billable*/3;
  Job_Unit_Price: number;
  Job_Line_Amount: number;
  Job_Line_Discount_Amount: number;
  Job_Line_Discount_Percent: number;
  Job_Total_Price: number;
  Job_Unit_Price_LCY: number;
  Job_Total_Price_LCY: number;
  Job_Line_Amount_LCY: number;
  Job_Line_Disc_Amount_LCY: number;
  Requested_Receipt_Date: Date;
  Promised_Receipt_Date: Date;
  Planned_Receipt_Date: Date;
  Expected_Receipt_Date: Date;
  Planning_Flexibility: /**Unlimited*/0 |/**None*/1;
  Prod_Order_No: string;
  Prod_Order_Line_No: number;
  Operation_No: string;
  Work_Center_No: string;
  Finished: boolean;
  Blanket_Order_No: string;
  Blanket_Order_Line_No: number;
  Appl_to_Item_Entry: number;
  Gemeindenr: string;
  Gen_Bus_Posting_Group: string;
  Verteilung: number;
  ShortcutDimCode3: string;
  ShortcutDimCode4: string;
  ShortcutDimCode5: string;
  ShortcutDimCode6: string;
  ShortcutDimCode7: string;
  ShortcutDimCode8: string;
  Investitionsnr: string;
  Investitionsname: string;
  Vorabdotierungsnr: string;
  Vorgangsnummer: string;
  Mittelherkunft: Mittelherkunft_5010395;
  Verpf_Ermächtigungsnr: string;
  Jahr_für_VE: number;
  Auftragsnummer: string;
  WorkOrderNo: string;
  IncidentNo: string;
  ActivityType: string;
  ComObj: string;
  ComObjUnit: string;
  Lead_Time_Calculation: string;
  Whse_Outstanding_Qty_Base: number;
  Inbound_Whse_Handling_Time: string;
  FA_Posting_Date: Date;
  Depreciation_Book_Code: string;
  Depr_until_FA_Posting_Date: boolean;
  FA_Posting_Type: /**_blank_*/0 |/**Acquisition_Cost*/1 |/**Maintenance*/2 |/**Appreciation*/3;
  FA_Quantity: number;
  Duplicate_in_Depreciation_Book: string;
  Deferral_Code: string;
  Document_No: string;
  Line_No: number;
  VAT_Amount: number;
  Over_Receipt_Quantity: number;
  Over_Receipt_Code: string;
  ContractNo: string;
  ContractLineNo: number;
  AmountBeforeDiscount: number;
  Invoice_Discount_Amount: number;
  Invoice_Disc_Pct: number;
  Total_Amount_Excl_VAT: number;
  Total_VAT_Amount: number;
  Total_Amount_Incl_VAT: number;
}

export interface IFWFData extends IPageObj {
  TableID: number;
  FieldID: number;
  Value: string;
}
